function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteOrgToCoalition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 720,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M0 0C4.33734 7.2655 6.92142 11.6544 16 10L20 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M16 10C6.83006 11.0566 6.07781 6.28027 0 1L0 683L30 687L30 688L24 688L24 689L32 689L32 693L33 693L34 688L39 690L40 690L48 691L48 683C55.6224 689.694 69.776 691.165 80 692L80 688C86.9217 686.435 98.6949 679.814 104 688C108.428 686.125 111.238 683.889 112 679L128 677C131.597 693.871 158.4 676.55 167 677.028C170.583 677.227 182.628 680.138 184 678L185 678L186 678C189.923 682.489 202.598 680.003 208 679L214 688C209.516 688.302 206.794 689.324 206 694L232.715 688.603L240.961 690.052L257.285 682.018L269.326 687.49L281 688L281 680L282 680L282 688L283 688L286 680L285 720L322 720L317 681L318 681L319 684L320 684C322.488 680.275 325.018 676.597 330 677.047C335.993 677.589 340.871 682.663 347 682.722C354.016 682.79 363.181 683.542 370 682.631C382.074 681.019 389.106 676.393 401 684L402 680L403 680C401.937 687.854 397.498 694.864 398.098 703C399.946 728.079 436.604 720 454 720L454 719C441.073 707.991 454.237 695.588 462.472 686.065C464.399 683.836 467.596 682.775 468 680C477.181 686.195 494.436 677.98 505 677.093C513.379 676.389 519.902 679.972 528 680C529.449 686.21 537.651 687.338 543 688L540 686L540 685L544 684L544 688L552 688L552 684L544 684L544 683L556 683L554 685L557 688C564.284 687.505 575.631 686.14 582 690L583 690L584 690L589 688L587 685L600 682.255L608.999 684.639L624 680C628.131 673.561 634.437 679.21 640 680L640 684C650.73 683.867 657.672 677.287 668 676.116C675.389 675.278 682.608 680.175 689 675L690 680L695 682L696 682L699 680L699 695L699 696L696 697C691.34 705.653 678.135 713.619 670 719L670 720C679.087 720 681.049 718.337 688 713L685 720L734 720L733 714L735 720C746.094 720 776.101 725.695 778 712L779 712L779 714L780 714L783 704L782 701L784 702L788 690L789 690L791 699L792 699L792 694L795 704L796 704L797 692C801.582 691.018 799.929 683.982 801 680L802 680L801 688L808 694L824 690L822 687L832 687L832 691L847 678L851 688L855 688L855 685L865.946 685.052L874.054 690.514L892 688L894 696L904 694L904 688L910 696C905.623 697.27 904.337 699.546 904 704L900 707L912 699L914 697L915 697L917 699C919.124 696.119 920.393 690.703 924 694L925 688L927 688L926 700L933 700L946 680L943 696L959.001 700.035L976 692L984 693L976 700L991 708L992 704L993 704L994 720L995 720C995 711.574 989.007 692.765 997 688L1000 698L1008 699L1008 707L1013 707L1013 706L1011 706L1011 705L1016 706L1016 702L1024 704L1028 691L1029 691L1030 701L1033 697C1037.46 701.93 1037.02 705.685 1037 712L1038 712L1038 704C1042.14 703.289 1043.7 701.119 1044 697L1048 696L1048 699L1056 694L1054 712L1056 712C1057.34 707.674 1059.84 707.806 1064 708C1064.13 712.351 1067.42 720.158 1072.11 713.847C1075.03 709.912 1073.66 704.835 1077 701L1080 713C1077.16 716.977 1079.75 719.323 1084 720L1086 714L1096 715L1096 720L1100 720L1100 715L1098 712C1104.41 708.526 1105.21 708.357 1112 711L1111 714L1112 714L1120 707L1124 704L1128 717L1121 714L1120 720L1133 720L1134 717L1135 717L1138 720L1142 712L1143 719L1144 719L1144 715L1147 715C1149.87 722.803 1155.32 718.617 1160 715L1160 720C1165.23 718.592 1170.77 714.627 1176 718L1184 716L1184 720L1188 720L1189 715L1192 716L1192 720L1200 717L1200 712L1204 707L1206 707L1208 712L1204 712L1202 720L1216 720L1213 717L1213 716L1222 712L1221 710L1222 709L1224 711L1240 707L1240 711L1232 710L1230 720L1232 720L1233 712L1235 720L1244 720L1245 716L1246 716C1250.74 723.72 1270.74 720 1279 720L1279 0L312 0L86 0L35 0C26.0195 0 17.5738 -1.08319 16 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1279 0L1279 720L1280 720L1280 209L1280 62L1280 20L1279 0M463 108L463 109L467 109L463 108M430 109L429 112L426 111L426 112L426 120L431 122L435 111L430 109M387 127L388 128L387 127M466 140L469 142L466 140M471 142L472 143L471 142M468 154L468 155L472 155L468 154M473 156L474 157L473 156M431 159L432 160L431 159M390 174L390 176L392 176L390 174M432 176L433 177L432 176M389 179L388 182L389 179M415.333 184.667L415.667 185.333L415.333 184.667M371 201L374 200L371 201M579 199L580 200L579 199M432 200L433 201L432 200M438.667 201.333L439.333 201.667L438.667 201.333M370.333 202.667L370.667 203.333L370.333 202.667M535.667 202.333L536.333 202.667L535.667 202.333M433 203L433 204L436 204L433 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M534 203L533 205L534 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M526 324C530.317 322.759 538.811 314.262 538.079 309.224C537.657 306.314 533.454 305.458 532.238 302.867C529.329 296.674 539.183 290.261 544 289L548 272L550 272L554 285L555 285C559.083 279.642 563.401 274.96 570 273C569.185 278.52 567.496 284.664 563.775 288.961C561.731 291.322 555.658 294.783 556.752 298.585C557.794 302.207 567.938 304.61 570.96 306.927C576.38 311.083 576.944 318.104 581.649 322.258C587.094 327.065 604.03 324.014 611 324C613.849 323.994 618.185 324.553 619.933 321.682C623.707 315.483 616.684 301.682 618.316 294C620.497 283.732 629.38 282.94 635.892 276.786C638.784 274.054 642.213 268.468 640.382 264.302C639.092 261.368 634.496 260.634 632.184 258.606C621.458 249.191 612 243.999 612 229C595.195 236.698 582.666 254.947 580 273C559.51 265.062 557.969 237.197 549.244 220C546.71 215.005 543.248 207.417 538.004 204.752C534.59 203.016 532.982 206.354 531.816 209.005C530.201 212.673 529.248 217.571 526.351 220.487C523.217 223.642 517.859 223.552 514.039 225.558C510.732 227.294 508.742 230.396 505.961 232.773C500.849 237.142 486.425 234.853 483.746 240.317C480.49 246.959 487.925 256.894 493.004 260.297C498.177 263.763 505.069 261.851 509.671 266.279C522.685 278.799 522.892 307.319 526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M537 203L538 204L537 203M538 204L539 205L538 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M532 205L533 206L532 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M539 205L540 206L539 205M532.333 206.667L532.667 207.333L532.333 206.667M540 206L541 207L540 206M541 207L542 208L541 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M367 208L368 209L367 208M394.667 208.333L395.333 208.667L394.667 208.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M531 208L532 209L531 208M542 208L543 209L542 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M531 209L532 210L531 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M364 210L365 211L364 210M392 210L392 213L391 213L389 212L389 224L398 227L396 229L400 232L401 219L396 220L397 211L392 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M543 210L544 211L543 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M530 211L531 212L530 211M544 211L545 212L544 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M363 212L361 216L363 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M530 212L531 213L530 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M545 212L546 213L545 212M584.333 212.667L584.667 213.333L584.333 212.667M529 213L530 214L529 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M545 213L546 214L545 213M529 214L530 215L529 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M546 214L547 215L546 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M436 217L441 215L436 217M585.667 215.333L586.333 215.667L585.667 215.333M407 216L408 217L407 216M416 216L416 218L418 216L416 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M528 216L529 217L528 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M547 216L548 217L547 216M528 217L529 218L528 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M548 217L549 218L548 217M432 218L428 220L429 222L424 222L424 227L432 227C433 223.279 435.677 220.73 432 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M548 218L549 219L548 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M359 219L352 229C356.15 226.994 361.011 224.168 359 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M527 219L528 220L527 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M549 219L550 220L549 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M549 220L550 221L549 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M525 221L526 222L525 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M526 221L527 222L526 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M550 221L551 222L550 221M521 222L522 223L521 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M522 222L523 223L522 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M523 222L524 223L523 222M550 222L551 223L550 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M518 223L519 224L518 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M519 223L520 224L519 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M551 223L552 224L551 223M587 223L590 225L587 223M401.333 224.667L401.667 225.333L401.333 224.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M515 224L516 225L515 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M516 224L517 225L516 224M551 224L552 225L551 224M513 225L514 226L513 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M412 226L413 229L412 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M511 226L512 227L511 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M552 226L553 227L552 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M392.667 227.333L393.333 227.667L392.667 227.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M510 227L511 228L510 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M509 228L510 229L509 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M553 228L554 229L553 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M606 228L607 229L606 228M610 228L610 229L613 229L610 228M415 229L414 232L415 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M509 229L510 230L509 229M553 229L554 230L553 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M609 229L610 230L609 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M612 229L613 230L612 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M406 230L407 240C410.768 236.953 410.206 232.207 406 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M508 230L509 231L508 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M554 230L555 231L554 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M608 230L609 231L608 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M612 230L612 241L613 241L612 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M507 231L508 232L507 231M554 231L555 232L554 231M607 231L608 232L607 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M506 232L507 233L506 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M606 232L607 233L606 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M400.667 233.333L401.333 233.667L400.667 233.333M416.667 233.333L417.333 233.667L416.667 233.333M505 233L506 234L505 233M555 233L556 234L555 233M602 233L603 234L602 233M604 233L605 234L604 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M605 233L606 234L605 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M405 234L406 235L405 234M503 234L504 235L503 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M504 234L505 235L504 234M555 234L556 235L555 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M603 234L604 235L603 234M400.333 235.667L400.667 236.333L400.333 235.667M499 235L500 236L499 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M500 235L501 236L500 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M501.667 235.333L502.333 235.667L501.667 235.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M602 235L603 236L602 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M491 236L491 237L494 237L491 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M494.667 236.333L495.333 236.667L494.667 236.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M496 236L496 237L499 237L496 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M556 236L557 237L556 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M601 236L602 237L601 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M667.667 236.333L668.333 236.667L667.667 236.333M405 237L406 238L405 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M485 237L486 238L485 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M486 237L486 238L490 238L486 237M556.333 237.667L556.667 238.333L556.333 237.667M600 237L601 238L600 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M664 237L665 238L664 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M665 237L666 238L665 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M671 253L662 252L661 253L661 255C665.11 256.978 676.39 258.395 673.377 250.104C671.953 246.184 666.97 244.793 665 241L674 241C670.515 237.233 660.908 235.927 662.377 243.899C663.076 247.695 668.691 250.057 671 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M669.667 237.333L670.333 237.667L669.667 237.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M671 237L672 238L671 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M681 237L682 238L681 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M681 257L682 257L682 238L685 238L685 245C685.782 243.115 685.315 234.722 682.008 238.662C679.069 242.164 681 252.6 681 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M685 237L686 238L685 237M694 237L695 238L694 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M694 245L695 245L695 238L699 239C694.349 235.828 694.043 241.368 694 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M698 237L699 238L698 237M705 237L706 238L705 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M706 237L706 238L719 238L706 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M725 237L725 257L726 257L725 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M726 237L726 238L729 238L729 254L730 254C730 248.611 732.177 239.05 726 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M729 237L730 238L729 237M738 237L739 238L738 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M738 241L739 241L739 238L755 238C750.205 235.988 739.907 235.255 738 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M755 237L756 238L755 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M760 237L761 238L760 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M760 257L761 257L761 238L774 239C759.577 228.073 760 248.505 760 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M773 237L774 238L773 237M780 237L781 238L780 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M780 257L781 257L781 238L790 238C777.173 232.619 780 249.34 780 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M790 237L791 238L790 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M400.667 238.333L401.333 238.667L400.667 238.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M599 238L600 239L599 238M663 238L664 239L663 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M672 238L674 240L672 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M673 238L674 239L673 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M682 238L682 257L685 257C685.128 246.19 694.872 246.19 695 257L698 257L698 238L695 238L695 245L685 245L685 238L682 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M705 238L706 258L707 258L705 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M706 238L706 257L719 257L719 254C712.233 253.976 706.094 248.756 716 248L716 245L709 245L709 241C712.987 240.997 716.668 241.598 719 238L706 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M719 238L720 239L719 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M726 238L726 257L738 257L738 254L729 254L729 238L726 238M739 238L739 241L745 241L745 257C751.023 255.001 749 246.262 749 241L755 241L755 238L739 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M755.333 238.667L755.667 239.333L755.333 238.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M761 238L761 257L774 257L774 254L764 254C764.709 249.556 766.606 248.335 771 248L764 245L764 241L774 240L761 238M781 238L781 257L784 257L784 250L796 257C791.247 245.363 797.361 238 781 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M792 238L793 239L792 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M483 239L484 240L483 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M557 239L558 240L557 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M598 239L599 240L598 239M662 239L663 240L662 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M698 239L698 257L699 257L698 239M793 239L794 240L793 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M416.667 240.333L417.333 240.667L416.667 240.333M482 240L482 244L483 244L482 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M557.333 240.667L557.667 241.333L557.333 240.667M597 240L598 241L597 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M661 240L662 241L661 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M667.667 240.333L668.333 240.667L667.667 240.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M674 240L675 241L674 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M718 240L719 241L718 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M755 240L756 241L755 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M773 240L774 241L773 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M794 240L795 241L794 240M595 241L596 242L595 241M613 241L614 242L613 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M661 241L661 244L662 244L661 241M665 241L666 242L665 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M669 241L670 242L669 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M670 241L671 242L670 241M673 241L674 242L673 241M709 241L709 245L710 245L709 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M710 241L710 242L719 242L710 241M740 241L741 242L740 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M744 241L745 242L744 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M749 241L750 242L749 241M754 241L755 242L754 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M764 241L764 245L765 245L764 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M766 241L766 242L773 242L766 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M784 241L785 242L784 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M785 241L785 246L790 246C789.423 242.526 788.474 241.577 785 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789 241L790 242L789 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M794 241L795 242L794 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M418.333 242.667L418.667 243.333L418.333 242.667M558 242L559 243L558 242M594 242L595 243L594 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M613 242L614 243L613 242M665 242L666 243L665 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M671 242L672 243L671 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M672 242L673 243L672 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M744 242L745 243L744 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M784 242L788 247L788 246L785 246L784 242M790 242L791 243L790 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M558 243L559 244L558 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M593 243L594 244L593 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M613 243L614 244L613 243M665 243L666 244L665 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M744 243L744 256L745 256L744 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M790.333 243.667L790.667 244.333L790.333 243.667M406 244L403 248L407 256L405 248C408.877 250.384 412.518 252.177 413 257L415 254L419 255L420 247L411 248L412 251L411 251L408 249L406 244M592 244L593 245L592 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M614 244L615 245L614 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M661 244L662 245L661 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M666 244L667 245L666 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M667 244L668 245L667 244M689.667 244.333L690.333 244.667L689.667 244.333M399 245L401 248L399 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M559 245L560 246L559 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M591 245L592 246L591 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M615 245L616 246L615 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M616 245L617 246L616 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M617 245L618 246L617 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M668 245L669 246L668 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M669 245L670 246L669 245M716 245L717 246L716 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M770 245L771 246L770 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M771 245L771 248L772 248L771 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M790 245L791 246L790 245M794.333 245.667L794.667 246.333L794.333 245.667M483 246L484 247L483 246M559 246L560 247L559 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M590 246L591 247L590 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M618 246L619 247L618 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M619 246L620 247L619 246M662 246L663 247L662 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M670 246L671 247L670 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M671 246L672 247L671 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M716 246L710 248L710 249C712.575 248.958 716.542 249.286 716 246M784 246L785 247L784 246M788.667 246.333L789.333 246.667L788.667 246.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M483 247L484 248L483 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M620 247L621 248L620 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M621 247L622 248L621 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M663 247L664 248L663 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M664 247L665 248L664 247M672 247L673 248L672 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M560 248L561 249L560 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M589 248L590 249L589 248M622 248L623 249L622 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M623 248L624 249L623 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M665 248L666 249L665 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M666 248L667 249L666 248M673 248L674 249L673 248M686 248L686 249L694 249L686 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M716 248L717 249L716 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M765 248L765 249L771 249L765 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M771 248L772 249L771 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M792 248L793 249L792 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M399.333 249.667L399.667 250.333L399.333 249.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M484 249L485 250L484 249M560 249L561 250L560 249M588 249L589 250L588 249M624 249L625 250L624 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M667 249L668 250L667 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M668 249L669 250L668 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M674 249L675 250L674 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M685 249L685 257L686 257L685 249M694 249L694 257L695 257L694 249M709 249L709 253L710 253L709 249M764 249L764 254L765 254L764 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M484 250L485 251L484 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M587 250L588 251L587 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M625 250L626 251L625 250M674 250L674 254L675 254L674 250M784 250L785 251L784 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M785 250L786 251L785 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M786 250L787 251L786 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M787 250L788 251L787 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M792 250L793 251L792 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M414.333 251.667L414.667 252.333L414.333 251.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M561 251L562 252L561 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M587 251L588 252L587 251M626 251L627 252L626 251M662 251L663 252L662 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M663 251L664 252L663 251M670.333 251.667L670.667 252.333L670.333 251.667M784 251L784 257L785 257L784 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M788 251L789 252L788 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M793 251L794 252L793 251M408 252L409 253L408 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M485 252L486 253L485 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M561 252L562 253L561 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M586 252L587 253L586 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M627 252L628 253L627 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M660 252L661 253L660 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M661 252L662 253L661 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M664 252L665 253L664 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M793 252L794 253L793 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M410 253L412 256L410 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M486 253L487 254L486 253M586 253L587 254L586 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M628 253L629 254L628 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M660 253L661 254L660 253M665 253L666 254L665 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M666 253L666 254L669 254L666 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M669 253L670 254L669 253M710 253L710 254L719 254L710 253M730 253L730 254L738 257C739.031 252.412 733.225 253.011 730 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M738 253L739 254L738 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M765 253L765 254L774 254L765 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M789 253L790 254L789 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M794 253L795 254L794 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M486 254L487 255L486 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M562 254L563 255L562 254M585 254L586 255L585 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M628 254L629 255L628 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M660 254L661 255L660 254M674 254L675 255L674 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M719 254L719 257L720 257L719 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M774 254L774 257L775 257L774 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M790 254L791 255L790 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M795 254L796 255L795 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M487 255L488 256L487 255M562 255L563 256L562 255M585 255L586 256L585 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M629 255L630 256L629 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M661 255L662 256L661 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M673 255L674 256L673 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M791 255L792 256L791 255M488 256L489 257L488 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M563 256L564 257L563 256M584 256L585 257L584 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M630 256L631 257L630 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 256L664 257L663 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M672 256L673 257L672 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M744 256L745 257L744 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M748 256L749 257L748 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M796 256L797 257L796 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M409 257L408 265L409 265L408 262C411.141 261.054 412.069 260.293 412 257L411 257L412 260L409 260L409 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M489 257L490 258L489 257M563 257L564 258L563 257M584 257L585 258L584 257M630 257L631 258L630 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M664 257L665 258L664 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M665 257L666 258L665 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M666 257L666 258L670 258L666 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M670 257L671 258L670 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M682 257L682 258L685 258L682 257M695 257L695 258L698 258L695 257M707 257L708 258L707 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M708 257L708 258L719 258L708 257M726 257L726 258L738 258L726 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M745 257L745 258L749 258L745 257M760 257L761 258L760 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M761 257L761 258L773 258L761 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M773 257L774 258L773 257M781 257L781 258L784 258L781 257M793 257L793 258L796 258L793 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M490 258L491 259L490 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M564 258L565 259L564 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M631 258L632 259L631 258M491 259L492 260L491 259M564 259L565 260L564 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M583 259L584 260L583 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M632 259L633 260L632 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M633 259L634 260L633 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M410 260L411 261L410 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M492 260L493 261L492 260M565 260L566 261L565 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M583 260L584 261L583 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M634 260L635 261L634 260M494 261L495 262L494 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M566 261L567 262L566 261M582 261L583 262L582 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M636 261L637 262L636 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M637 261L638 262L637 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M638 261L639 262L638 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M496 262L497 263L496 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M497 262L498 263L497 262M566 262L567 263L566 262M582.333 262.667L582.667 263.333L582.333 262.667M640 262L641 263L640 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M499 263L500 264L499 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M500 263L501 264L500 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M501 263L501 264L506 264L501 263M567 263L568 264L567 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M641 263L641 268L642 268L641 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M507 264L508 265L507 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M508 264L509 265L508 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M568 264L569 265L568 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M581 264L582 265L581 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M509 265L510 266L509 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M569 265L570 266L569 265M581 265L582 266L581 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M510 266L511 267L510 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M570 266L571 267L570 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M581 266L582 267L581 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M571 267L572 268L571 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M511 268L512 269L511 268M572 268L573 269L572 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M580 268L581 269L580 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M512 269L513 270L512 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M573 269L574 270L573 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M580 269L581 270L580 269M640 269L641 270L640 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M667 269L668 270L667 269M683 269L684 270L683 269M719 269L721 271L719 269M736 269L735 271L736 269M751.667 269.333L752.333 269.667L751.667 269.333M790.667 269.333L791.333 269.667L790.667 269.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M512 270L513 271L512 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M574 270L575 271L574 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M575 270L576 271L575 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M640 270L641 271L640 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M667 270L659 290L677 290L669 270L667 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M682 270L682 290L683 290L682 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M683 270L683 290L686 290L686 278L699 290L699 270L695 271L695 282L694 282L683 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M684 270L685 271L684 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 270L696 271L695 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M699 270L700 271L699 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M707 270L708 271L707 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M708 270L707 290L711 290L710 270L708 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M710 270L711 271L710 270M718 270L718 290L719 290L718 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M719 270L719 290L722 290L722 281L727 286L729 286L734 281L734 290L737 290L737 270L736 270C728.437 280.2 727.201 277.278 719 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M737 270L737 290L738 290L737 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M751 270L743 290C748.537 289.143 752.227 285.131 757 290L761 289L753 270L751 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M766 270C766 283.521 763.419 291 779 291L779 290L767 290L766 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M767 270L767 290L779 290L779 287L771 287C770.796 281.568 773.228 272.067 767 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M770 270L771 271L770 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M787 270L788 271L787 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M784 285C786.578 290.112 798.803 292.219 797.168 284C796.516 280.718 788.946 278.084 789.631 275.289C790.094 273.401 795.524 274.204 797 274C793.873 270.457 784.684 268.182 785.466 275.989C786.114 282.458 799.086 287.501 784 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M793 270L794 271L793 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M794 270L795 271L794 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 271L514 272L513 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M576 271L577 272L576 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M579 271L578 273L580 273L579 271M640 271L641 272L640 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M666 271L667 272L666 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M669 271L670 272L669 271M685 271L686 272L685 271M699 271L699 290L700 290L699 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M706 271L706 290L707 290L706 271M711 271L711 280L712 280L711 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M750 271L751 272L750 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M753 271L754 272L753 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786 271L787 272L786 271M795 271L796 272L795 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M404 272L395 279L395 280C398.986 278.947 404.12 276.653 404 272M513 272L514 273L513 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M548 272L549 273L548 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M577 272L578 273L577 272M639 272L640 273L639 272M669 272L670 273L669 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M686 272L687 273L686 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 272L696 273L695 272M721 272L722 273L721 272M734 272L735 273L734 272M785 272L786 273L785 272M796 272L797 273L796 272M514 273L515 274L514 273M547 273L548 274L547 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M550 273L551 274L550 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M567 273L568 274L567 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M568 273L569 276L570 276L568 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M569 273L570 274L569 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M639 273L640 274L639 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M665 273L666 274L665 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M670 273L671 274L670 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M687 273L688 274L687 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M722 273L723 274L722 273M733 273L734 274L733 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M749 273L750 274L749 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M754 273L755 274L754 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M784 273L785 274L784 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M789 273L789 274L792 274L789 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M797 273L798 274L797 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M514 274L515 275L514 274M547 274L548 275L547 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M565 274L566 275L565 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M638 274L639 275L638 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M665 274L666 275L665 274M670 274L671 275L670 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M688 274L689 275L688 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M723 274L724 275L723 274M732 274L733 275L732 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M749 274L750 275L749 274M754 274L755 275L754 274M784 274L784 277L785 277L784 274M788 274L789 275L788 274M793 274L794 275L793 274M796 274L797 275L796 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M514 275L515 276L514 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M551 275L552 276L551 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M563 275L564 276L563 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M564 275L565 276L564 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M637 275L638 276L637 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M664 275L665 276L664 275M671 275L672 276L671 275M689 275L690 276L689 275M724 275L725 276L724 275M731 275L732 276L731 275M748 275L749 276L748 275M755 275L756 276L755 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M788 275L789 276L788 275M794 275L795 276L794 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M795 275L796 276L795 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M515 276L516 277L515 276M546 276L547 277L546 276M562 276L563 277L562 276M569 276L570 277L569 276M636 276L637 277L636 276M664 276L665 277L664 276M671 276L672 277L671 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M690 276L691 277L690 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 276L696 277L695 276M724 276L725 277L724 276M748 276L749 277L748 276M755 276L756 277L755 276M788 276L789 277L788 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M515 277L516 278L515 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M546 277L547 278L546 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M552 277L553 278L552 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M561 277L562 278L561 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M635 277L636 278L635 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M663 277L664 278L663 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M725 277L726 278L725 277M730 277L731 278L730 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M747 277L748 278L747 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M784 277L785 278L784 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M789 277L790 278L789 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M790 277L791 278L790 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M545 278L546 279L545 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M552 278L553 279L552 278M560 278L561 279L560 278M568 278L569 279L568 278M634 278L635 279L634 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 278L664 279L663 278M667.667 278.333L668.333 278.667L667.667 278.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M672 278L673 279L672 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M686 278L686 289L687 289L686 278M695 278L695 281L696 281L695 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M726 278L727 279L726 278M729 278L730 279L729 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M747 278L748 279L747 278M751.667 278.333L752.333 278.667L751.667 278.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M756 278L757 279L756 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M785 278L786 279L785 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M792 278L793 279L792 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M516 279L517 280L516 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M545 279L546 280L545 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M559 279L560 280L559 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M568 279L569 280L568 279M632 279L633 280L632 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M667 279L666 284L670 284L667 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M668 279L669 280L668 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M672 279L673 280L672 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M687 279L688 280L687 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M727.667 279.333L728.333 279.667L727.667 279.333M751.667 279.333L752.333 279.667L751.667 279.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786 279L787 280L786 279M794 279L795 280L794 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M516 280L517 281L516 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M553.333 280.667L553.667 281.333L553.333 280.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M558 280L559 281L558 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M567 280L568 281L567 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M630 280L631 281L630 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M662 280L663 281L662 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M666 280L667 281L666 280M669.333 280.667L669.667 281.333L669.333 280.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M673 280L674 281L673 280M688 280L689 281L688 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M693 280L694 281L693 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M746 280L747 281L746 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M750 280L751 281L750 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M751 280L750 284L754 284L753 280L751 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M753 280L754 281L753 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M757 280L758 281L757 280M787 280L788 281L787 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M795 280L796 281L795 280M544 281L545 282L544 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M557 281L558 282L557 281M567 281L568 282L567 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M627 281L628 282L627 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M628 281L629 282L628 281M666 281L667 282L666 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M673 281L674 282L673 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M689 281L690 282L689 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M694 281L695 282L694 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M722 281L723 282L722 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M723 281L724 282L723 281M732 281L733 282L732 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M733 281L734 282L733 281M746 281L747 282L746 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M750 281L751 282L750 281M753 281L754 282L753 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M757 281L758 282L757 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789 281L790 282L789 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M796 281L797 282L796 281M517 282L518 283L517 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M544 282L545 283L544 282M553 282L554 283L553 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M556 282L557 283L556 282M567 282L568 283L567 282M625 282L626 283L625 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M626 282L627 283L626 282M661 282L662 283L661 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M674 282L675 283L674 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M690 282L691 283L690 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M722 282L722 290L723 290L722 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M724 282L725 283L724 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M731 282L732 283L731 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M733 282L733 290L734 290L733 282M745 282L746 283L745 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M758 282L759 283L758 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M770 282L771 283L770 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M791 282L792 283L791 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M792 282L793 283L792 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M797 282L798 283L797 282M517 283L518 284L517 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M544 283L545 284L544 283M553 283L555 287L553 283M566 283L567 284L566 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M624 283L625 284L624 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M661 283L662 284L661 283M665 283L666 284L665 283M670 283L671 284L670 283M674 283L675 284L674 283M691 283L692 284L691 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M725 283L726 284L725 283M730 283L731 284L730 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M745 283L746 284L745 283M749 283L750 284L749 283M754 283L755 284L754 283M758 283L759 284L758 283M793 283L794 284L793 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M427 289L433 292L432 288L433 288L434 290L437 287C432.726 284.418 428.629 283.252 427 289M517 284L518 285L517 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M555 284L556 285L555 284M566 284L567 285L566 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M623 284L624 285L623 284M660 284L661 285L660 284M675 284L676 285L675 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M692 284L693 285L692 284M726 284L727 285L726 284M729 284L730 285L729 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M744 284L745 285L744 284M759 284L760 285L759 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M785.667 284.333L786.333 284.667L785.667 284.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M793 284L794 285L793 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M518 285L519 286L518 285M554 285L555 286L554 285M566 285L567 286L566 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M622 285L623 286L622 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M660 285L661 286L660 285M675 285L676 286L675 285M693 285L694 286L693 285M744 285L745 286L744 285M759 285L760 286L759 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M783 285L784 286L783 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M787 285L788 286L787 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M793 285L794 286L793 285M518.333 286.667L518.667 287.333L518.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M565 286L566 287L565 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M621 286L622 287L621 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M659 286L660 287L659 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M694 286L695 287L694 286M771 286L771 287L779 290C780.031 285.412 774.226 286.011 771 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M779 286L780 287L779 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M783 286L784 287L783 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789 286L790 287L789 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M790.667 286.333L791.333 286.667L790.667 286.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M792 286L793 287L792 286M797 286L798 287L797 286M543 287L544 288L543 287M565 287L566 288L565 287M659 287L660 288L659 287M664 287L665 288L664 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M665 287L665 288L671 288L665 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M671 287L672 288L671 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M676 287L677 288L676 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 287L696 288L695 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M743 287L744 288L743 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M748 287L749 288L748 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M749 287L750 288L749 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M750 287L751 288L750 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M751 287L751 288L756 288L751 287M760 287L761 288L760 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M784 287L785 288L784 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M564 288L565 289L564 288M620 288L621 289L620 288M658.333 288.667L658.667 289.333L658.333 288.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 288L664 289L663 288M672 288L673 289L672 288M676 288L677 289L676 288M747 288L748 289L747 288M756 288L757 289L756 288M785 288L786 289L785 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M796 288L797 289L796 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M519 289L520 290L519 289M541 289L542 290L541 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M542.667 289.333L543.333 289.667L542.667 289.333M563 289L564 290L563 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M619 289L620 290L619 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M672 289L673 290L672 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M686 289L687 290L686 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M742 289L743 290L742 289M756 289L757 290L756 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M760 289L761 290L760 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M786 289L787 290L786 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M794 289L795 290L794 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M795 289L796 290L795 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M519 290L520 291L519 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M538 290L539 291L538 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M539 290L540 291L539 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M562 290L563 291L562 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M619 290L620 291L619 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M660.667 290.333L661.333 290.667L660.667 290.333M683 290L684 291L683 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M698 290L699 291L698 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M708 290L709 291L708 290M719 290L720 291L719 290M734.667 290.333L735.333 290.667L734.667 290.333M744.667 290.333L745.333 290.667L744.667 290.333M758.667 290.333L759.333 290.667L758.667 290.333M788 290L789 291L788 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789 290L790 291L789 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M790 290L791 291L790 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M791.667 290.333L792.333 290.667L791.667 290.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M793 290L794 291L793 290M519 291L520 292L519 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M537 291L538 292L537 291M561 291L562 292L561 291M536 292L537 293L536 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M559 292L560 293L559 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M560 292L561 293L560 292M618 292L619 293L618 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M390.667 293.333L391.333 293.667L390.667 293.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M520.333 293.667L520.667 294.333L520.333 293.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M558 293L559 294L558 293M618 293L619 294L618 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M535 294L536 295L535 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M557 294L558 295L557 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M618 294L619 295L618 294M520 295L521 296L520 295M534 295L535 296L534 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M556 295L557 296L556 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M398.667 296.333L399.333 296.667L398.667 296.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M533 296L534 297L533 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M392 297L393 298L392 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M532 297L533 298L532 297M555 297L556 298L555 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M521 298L522 299L521 298M531 298L532 299L531 298M555 298L556 299L555 298M617.333 298.667L617.667 299.333L617.333 298.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M521 299L522 300L521 299M531 299L532 300L531 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M555 299L556 300L555 299M521 300L522 301L521 300M556 300L557 301L556 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M557 300L558 301L557 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M531 301L532 302L531 301M559 301L560 302L559 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M560 301L561 302L560 301M531 302L532 303L531 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M562 302L563 303L562 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M563 302L564 303L563 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M618.333 302.667L618.667 303.333L618.333 302.667M667 302L668 303L667 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M668 302L669 303L668 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M669 302L670 303L669 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M670 302L671 303L670 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M671 302L672 303L671 302M690 302L691 303L690 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M691 302L692 303L691 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M692.667 302.333L693.333 302.667L692.667 302.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M694 302L695 303L694 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M695 302L696 303L695 302M711 302L712 303L711 302M722 302L723 303L722 302M724 302L725 303L724 302M731 302L732 303L731 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M732 302L733 303L732 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M745 302L746 303L745 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M522 303L523 304L522 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M564 303L565 304L564 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M565 303L566 304L565 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M664 303L665 304L664 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M665 303L666 304L665 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M678 318C674.165 317.365 669.666 320.562 666.228 318.214C661.988 315.317 662.932 308.227 668.044 306.886C670.714 306.185 673.596 308.067 676 309L677 308C666.055 287.145 647.568 329.061 671.995 322.425C674.756 321.675 676.273 320.125 678 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M673 303L674 304L673 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M674 303L675 304L674 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M688 303L689 304L688 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M689 303L690 304L689 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M690.004 303.573C677.657 307.099 683.839 326.042 695.996 322.343C708.354 318.584 702.512 300.002 690.004 303.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M697 303L698 304L697 303M708 303L709 304L708 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M709 303C709 307.75 707.771 314.613 710.179 318.891C713.32 324.47 721.866 323.826 724.258 317.956C726.017 313.639 725 307.586 725 303L722 303C722 306.973 723.462 318.793 716.975 318.793C710.379 318.793 712 307.042 712 303L709 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M712 303L713 304L712 303M721 303L722 304L721 303M725 303L726 304L725 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M731 303L731 322L732 322L731 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M732 303L732 323L735 323L735 311L748 323L748 303L745 303L745 314L732 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M733 303L734 304L733 303M744 303L744 314L745 314L744 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M748 303L748 323L749 323L748 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M753 303L753 306L754 306L753 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M754 303L754 306L760 306L761 323L763 323L764 306L770 306L770 303L754 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M770 303L771 304L770 303M522.333 304.667L522.667 305.333L522.333 304.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M532 304L533 305L532 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M566 304L567 305L566 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M567 304L568 305L567 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M618 304L619 305L618 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M662 304L663 305L662 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 304L664 305L663 304M675 304L676 305L675 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M686 304L687 305L686 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M699 304L700 305L699 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M708 304L708 316L709 316L708 304M712 304L712 317L713 317L712 304M721 304L721 316L722 316L721 304M725 304L726 305L725 304M734 304L735 305L734 304M770 304L764 306L764 307C766.575 306.958 770.542 307.286 770 304M533 305L534 306L533 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M534 305L535 306L534 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M568 305L569 306L568 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M569 305L570 306L569 305M618 305L618 308L619 308L618 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M661 305L662 306L661 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M676 305L677 306L676 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M685 305L686 306L685 305M700 305L701 306L700 305M725 305L725 310L726 310L725 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M735 305L736 306L735 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M522 306L523 307L522 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M536 306L537 307L536 306M570 306L571 307L570 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M660 306L661 307L660 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M667 306L667 307L672 307L667 306M677 306L676 309L677 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M684 306L685 307L684 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M690.667 306.333L691.333 306.667L690.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M692.667 306.333L693.333 306.667L692.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M694.667 306.333L695.333 306.667L694.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M701 306L702 307L701 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M736 306L737 307L736 306M754 306L754 307L760 307L754 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M770 306L771 307L770 306M538 307L539 308L538 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M571 307L572 308L571 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M660 307L661 308L660 307M665 307L666 308L665 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M666 307L667 308L666 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M672 307L673 308L672 307M689 307L688 309L689 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M690.228 308.032C684.019 311.696 689.494 321.343 695.852 317.806C702.244 314.25 696.488 304.339 690.228 308.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M696 307L697 308L696 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M702 307L703 308L702 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M737 307L738 308L737 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M764 307L764 322L765 322L764 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M523.333 308.667L523.667 309.333L523.333 308.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M539 308L540 309L539 308M572 308L575 311L572 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M573 308L574 309L573 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M659 308L660 309L659 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M664 308L665 309L664 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M677 308L678 309L677 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M683 308L684 309L683 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M697 308L698 309L697 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M702 308L703 309L702 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M738 308L739 309L738 308M539 309L540 310L539 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M574 309L575 310L574 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M619 309L620 310L619 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M659 309L660 310L659 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M674 309L675 310L674 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M675 309L676 310L675 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M687 309L688 310L687 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M698 309L699 310L698 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M703 309L704 310L703 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M739 309L740 310L739 309M523 310L524 311L523 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M619.333 310.667L619.667 311.333L619.333 310.667M663 310L664 311L663 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M682 310L683 311L682 310M687 310L688 311L687 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M703 310L704 311L703 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M725 310L725 313L726 313L725 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M740 310L741 311L740 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M523 311L524 312L523 311M538 311L539 312L538 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M575 311L576 312L575 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M658 311L659 312L658 311M663 311L664 312L663 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M682.333 311.667L682.667 312.333L682.333 311.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M686 311L686 314L687 314L686 311M699 311L699 315L700 315L699 311M703 311L703 315L704 315L703 311M735 311L735 322L736 322L735 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M741 311L742 312L741 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M760 311L761 312L760 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M537 312L538 313L537 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M576 312L577 313L576 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M658.333 312.667L658.667 313.333L658.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M736 312L737 313L736 312M742 312L743 313L742 312M536 313L537 314L536 313M576 313L577 314L576 313M637 313L649 328L653 327L656 334L676 344L676 343L672 343L672 341L818 334L818 333C798.505 331.449 780.733 327.624 761 330.282C731.702 334.229 697.514 345.916 668.039 336.481C656.391 332.753 646.824 319.898 637 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M682 313L683 314L682 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M725 313L726 314L725 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M737 313L738 314L737 313M743 313L744 314L743 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M524.333 314.667L524.667 315.333L524.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M535 314L536 315L535 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M577 314L578 315L577 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M620 314L621 315L620 314M658 314L659 315L658 314M663 314L664 315L663 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M682 314L683 315L682 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M725 314L726 315L725 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M738 314L739 315L738 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M534 315L535 316L534 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M577 315L578 316L577 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M620 315L621 316L620 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 315L664 316L663 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M682 315L683 316L682 315M687 315L688 316L687 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M703 315L704 316L703 315M725.333 315.667L725.667 316.333L725.333 315.667M739 315L740 316L739 315M524.333 316.667L524.667 317.333L524.333 316.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M578 316L579 317L578 316M620.333 316.667L620.667 317.333L620.333 316.667M659 316L660 317L659 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M674 316L675 317L674 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M675 316L676 317L675 316M683 316L684 317L683 316M687 316L688 317L687 316M698 316L699 317L698 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M703 316L704 317L703 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M708 316L709 317L708 316M740 316L741 317L740 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M533 317L534 318L533 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M578 317L579 318L578 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M659 317L660 318L659 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M664 317L665 318L664 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M673 317L674 318L673 317M677 317L678 318L677 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M683 317L684 318L683 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M688 317L689 318L688 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M697 317L698 318L697 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M702 317L703 318L702 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M708 317L709 318L708 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M713 317L714 318L713 317M720 317L721 318L720 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M725 317L726 318L725 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M741 317L742 318L741 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M524.333 318.667L524.667 319.333L524.333 318.667M578 318L579 319L578 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M660 318L661 319L660 318M665 318L666 319L665 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M666 318L667 319L666 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M672 318L673 319L672 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M684 318L685 319L684 318M689 318L690 319L689 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M690 318L691 319L690 318M695 318L696 319L695 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M696 318L697 319L696 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M702 318L703 319L702 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M709 318L710 319L709 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M714 318L715 319L714 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M719 318L720 319L719 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M724 318L725 319L724 318M742 318L743 319L742 318M532 319L533 320L532 319M579 319L580 320L579 319M667 319L667 320L671 320L667 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M677 319L678 320L677 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M684 319L685 320L684 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M691 319L691 320L695 320L691 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M701 319L702 320L701 319M709 319L710 320L709 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M715 319L715 320L719 320L715 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M724 319L725 320L724 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M743 319L744 320L743 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M579 320L580 321L579 320M621 320L622 321L621 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M662 320L663 321L662 320M676 320L677 321L676 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M685 320L686 321L685 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M700 320L701 321L700 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M710 320L711 321L710 320M723 320L724 321L723 320M744 320L745 321L744 320M525 321L526 322L525 321M531 321L532 322L531 321M580 321L581 322L580 321M663 321L664 322L663 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M675 321L676 322L675 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M686 321L687 322L686 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M687 321L688 322L687 321M698 321L699 322L698 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M699 321L700 322L699 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M711 321L712 322L711 321M722 321L723 322L722 321M745 321L746 322L745 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M525 322L526 323L525 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M530 322L531 323L530 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M580 322L581 323L580 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M620 322L619 324L620 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M664 322L665 323L664 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M665 322L666 323L665 322M672.667 322.333L673.333 322.667L672.667 322.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M688 322L689 323L688 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M689 322L690 323L689 322M696 322L697 323L696 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M697 322L698 323L697 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M712 322L713 323L712 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M713 322L714 323L713 322M720 322L721 323L720 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M721 322L722 323L721 322M731 322L732 323L731 322M735 322L736 323L735 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M746 322L747 323L746 322M760 322L761 323L760 322M763 322L764 323L763 322M529 323L530 324L529 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M581 323L582 324L581 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M582 323L583 324L582 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M620 323L621 324L620 323M667 323L668 324L667 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M668 323L668 324L671 324L668 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M671 323L672 324L671 323M691 323L692 324L691 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M692 323L693 324L692 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M693.667 323.333L694.333 323.667L693.667 323.333M715 323L716 324L715 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M716 323L716 324L719 324L716 323M747 323L748 324L747 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M526 324L527 325L526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M527.667 324.333L528.333 324.667L527.667 324.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M583 324L584 325L583 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M584.667 324.333L585.333 324.667L584.667 324.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M586 324L586 325L618 325L586 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M618 324L619 325L618 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M649 326L650 327L649 326M763.667 331.333L764.333 331.667L763.667 331.333M744 334L744 335L753 334L744 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M832 337L833 338L832 337M836.667 338.333L837.333 338.667L836.667 338.333M839 338L841 340L839 338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M667 340L667 341L675 340L667 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M784 339L785 340L784 339M786 339L786 340L792 340L786 339M800 339L800 340L804 341L804 340L800 339M768 341L768 342L783 341L768 341M677 341L677 343L685 343L677 341M840 341L841 342L840 341M846 341L852 344L852 343L846 341M688 343L688 344L696 344L700 347L708 345L712 348L712 347L709 345L716 345L688 343M745 345L752 346C752 342.817 754.615 344.31 757 345C754.329 341.539 747.817 341.76 745 345M686 343L687 344L686 343M562 344L561 358L562 358L562 345L565 347L562 344M582 344L583 345L582 344M618.667 344.333L619.333 344.667L618.667 344.333M651 344L652 345L651 344M662.667 344.333L663.333 344.667L662.667 344.333M682 344L683 345L682 344M684.667 344.333L685.333 344.667L684.667 344.333M717 344L717 345L721 345L721 347L716 347L716 348L722 347L722 345L717 344M722 344L723 345L722 344M726 344L726 345L732 347L731 344L726 344M732 344L732 345L735 347L736 344L732 344M737 344L737 350L738 350L738 345L743 345L737 344M763 344L764 345L763 344M766 344L766 347L767 347L768 344L766 344M769 344L769 345L772 345L769 344M853 344L858 349L857 344L853 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M509.333 345.667L509.667 346.333L509.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M510 345L510 347L514 347L514 357L515 357L515 347L519 347L519 345L510 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M514 345L515 346L514 345M519.333 345.667L519.667 346.333L519.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M524 345L525 346L524 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M525 345C523.847 348.54 522.229 356.4 527 357L527 356L525 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M526 345L526 349L527 349L526 345M532 345L532 350L533 350L532 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M533 345L533 350L526 350L526 346L525 346L525 357L526 357L526 352L533 352L533 357L534 357L533 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M534 345L533 358L534 358L534 345M540 345C540 352.401 539.301 359.835 549 357L549 356L541 357L540 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M541 345L541 357L548 357L548 356L542 356L542 352L546 352L546 350L542 350L542 347L548 347L548 345L541 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M548 345L549 346L548 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M562 345L562 357L564 357L564 350L572 357L572 346L570 346L570 353L562 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M570.667 345.333L571.333 345.667L570.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M572 345L572 358L573 358L572 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M581 345L582 346L581 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M582 345L581 347L582 345M590.333 345.667L590.667 346.333L590.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M591 345L591 347L595 347L595 357L596 357L596 347L600 347L600 345L591 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M600.333 345.667L600.667 346.333L600.333 345.667M605 345L606 358L607 358L605 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M606 345L606 357L607 357L606 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M607 345L607 357L608 357L607 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M615 345L616 346L615 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M616 345L617 346L616 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M617.059 345.786C610.099 348.227 613.624 359.262 620.892 356.758C627.933 354.331 624.2 343.282 617.059 345.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M621 345L622 346L621 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M622 345L623 346L622 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M630 345L631 358L632 358L632 345L630 345M638 345L638 352L633 350L639 353L638 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M639 345L639 353L636 352L640 357L639 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M640 345L641 346L640 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M650.667 345.333L651.333 345.667L650.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M661 345L661 357L662 357L661 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M662 345L662 357L669 357L669 356L663 356L662 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 345L663 356L664 356L663 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M680 345L681 346L680 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M681 345L682 346L681 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M681 346L681 357C694.46 356.952 692.706 343.084 681 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M686.667 345.333L687.333 345.667L686.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M688 345L689 346L688 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M699 345L700 346L699 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M700.667 345.333L701.333 345.667L700.667 345.333M709 345L710 346L709 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M709 346L709 347L713 347L713 357L715 357L715 347L719 347L719 345L709 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M719 345L720 346L719 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M720.333 345.667L720.667 346.333L720.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M726 345L727 346L726 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M727 345L722 357L732 357L727 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M738 345L739 346L738 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M738 357C740.054 356.993 742.779 357.359 744.679 356.397C751.609 352.887 738.616 337.725 738.019 351C737.93 352.993 738 355.005 738 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M743 345L744 346L743 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M744 345L745 346L744 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M753 345L754 346L753 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M756 345L757 346L756 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M757 345L758 346L757 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M768 345L767 347L768 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M773 356L767 355L767 356L774 357L769 347L774 348C772.485 345.89 767.274 344.4 767.921 348.85C768.279 351.319 771.824 353.713 773 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M772 345L773 346L772 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M773 345L774 346L773 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M780.667 345.333L781.333 345.667L780.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M780 357L788 357L788 356L782 356L782 352L786 352L786 350L782 350L782 347L788 347L788 345C779.506 345.206 780 349.686 780 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M788.333 345.667L788.667 346.333L788.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M548 346L549 347L548 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M582 346L577 357L587 357L582 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M583 346L584 347L583 346M614 346L615 347L614 346M623 346L624 347L623 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M631 346L631 357L632 357L632 350L635 351L631 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M632 346L633 347L632 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M640 346L641 347L640 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M649 346L650 347L649 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M650 346L646 357L656 357L652 346L650 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M652 346L653 349L654 349L652 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M689 346L691 348L689 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M690 346L691 347L690 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M700 346L696 357L706 357L702 346L700 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M702 346L703 347L702 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M719 346L720 347L719 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M724 346L725 347L724 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M728 346L729 347L728 346M745 346L746 347L745 346M755 346L756 347L755 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M756 346L752 357L762 357L758 346L756 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M760 346L762 348L760 346M774 346L775 347L774 346M859 346L860 347L859 346M510.667 347.333L511.333 347.667L510.667 347.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 347L514 348L513 347M515 347C515 351.023 516.19 356.797 513 356L513 357L515 358L515 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M516 347L517 348L516 347M518 347L519 348L518 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M542 347L542 350L543 350L542 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M543 347L544 348L543 347M545 347L545 348L548 348L545 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M564 347L565 348L564 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M580 347L581 348L580 347M591 347L591 348L594 348L591 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M594 347L595 358L596 358L594 347M596 347L597 348L596 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M598 347L598 348L601 348L598 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M613 347L614 348L613 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M616 347L615 349L616 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M617 347L618 348L617 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M618.13 347.971C613.817 349.051 615.445 355.571 619.816 354.623C624.221 353.668 622.505 346.874 618.13 347.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M620 347L621 348L620 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M621 347L622 348L621 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M624 347L625 348L624 347M633 347L634 348L633 347M640 347L640 358L641 358L640 347M649 347L650 348L649 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M652 347L653 348L652 347M681 347L681 350L682 350L681 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M683 347L683 355L684 355L683 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M684 347L684 348L687 348L684 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M687 347L688 348L687 347M699 347L700 348L699 347M702 347L703 348L702 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M712 347L713 348L712 347M715 347L715 357L716 357L715 347M725 347L726 348L725 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M728 347L729 348L728 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M740 347L740 348L744 349L744 348L740 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M743 347L744 348L743 347M745 347L746 348L745 347M755 347L756 348L755 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M758 347L759 348L758 347M766.333 347.667L766.667 348.333L766.333 347.667M769 347L770 348L769 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M771 347L772 348L771 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M772 347L773 348L772 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M774 347L775 348L774 347M782 347L783 348L782 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M783 347L783 348L788 348L783 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M513 348L513 356L514 356L513 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M565 348L566 349L565 348M580 348L581 349L580 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M584 348L585 349L584 348M596.333 348.667L596.667 349.333L596.333 348.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M612 348L613 349L612 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M622 348L623 349L622 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M634 348L635 349L634 348M648 348L649 349L648 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M684 348L684 355C689.714 354.046 689.714 348.954 684 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M688 348L689 349L688 348M691 348L692 349L691 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M703 348L704 349L703 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M725 348L726 349L725 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M729 348L730 349L729 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M740 348L740 350L743 350L743 348L740 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M747.667 348.333L748.333 348.667L747.667 348.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M754 348L755 349L754 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M758 348L759 349L758 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M773 348L774 349L773 348M782.333 348.667L782.667 349.333L782.333 348.667M864 348L867 350L867 349L864 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M526 349L527 350L526 349M566 349L567 350L566 349M582 349L581 351L582 349M584 349L585 350L584 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M612 349L613 350L612 349M625.333 349.667L625.667 350.333L625.333 349.667M648 349L649 350L648 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M650.667 349.333L651.333 349.667L650.667 349.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M653 349L654 350L653 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M655 349L656 350L655 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M689 349L690 350L689 349M691 349L692 350L691 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M698 349L699 350L698 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M700.667 349.333L701.333 349.667L700.667 349.333M703 349L704 350L703 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M705 349L706 350L705 349M712 349L713 350L712 349M724 349L725 350L724 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M727 349L726 351L727 349M729 349L730 350L729 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M731 349L732 350L731 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M743 349L744 350L743 349M745 349L746 350L745 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M746 349L747 350L746 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M754 349L755 350L754 349M756 349L758 351L756 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M759 349L760 350L759 349M766 349L767 350L766 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M769 349L770 350L769 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M770 349L771 350L770 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M546.333 350.667L546.667 351.333L546.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M564 350L565 351L564 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M567 350L568 351L567 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M579 350L580 351L579 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M582 350L581 353L582 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M585 350L586 351L585 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M596.333 350.667L596.667 351.333L596.333 350.667M612 350L612 353L613 353L612 350M614 350L614 353L615 353L614 350M623 350L623 353L624 353L623 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M632 350L633 351L632 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M648 350L649 351L648 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M650 350L651 351L650 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M651 350L652 351L651 350M654 350L655 351L654 350M686 350L687 351L686 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M689 350L690 351L689 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M695 350L696 351L695 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M698 350L699 351L698 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M700.667 350.333L701.333 350.667L700.667 350.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M718 350L719 351L718 350M720 350L722 352L720 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M724 350L725 351L724 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M727 350L728 351L727 350M730 350L731 351L730 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M737 350L738 351L737 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M740 350L740 351L743 351L740 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M745 350L746 351L745 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M748 350L749 351L748 350M753 350L754 351L753 350M756 350L758 352L756 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M759 350L760 351L759 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M767 350L768 351L767 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M771 350L772 351L771 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M772 350L773 351L772 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786.333 350.667L786.667 351.333L786.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M565 351L566 352L565 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M568 351L569 352L568 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M581 351L582 352L581 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M583 351L584 352L583 351M585 351L586 352L585 351M625 351L626 352L625 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M632 351L633 352L632 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M635 351L636 352L635 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M647 351L648 352L647 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M650 351L650 353L652 353L652 351L650 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M654 351L655 352L654 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M681 351L681 356L682 356L681 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M689 351L690 352L689 351M697 351L698 352L697 351M700 351L701 352L700 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M701 351L700 353L702 353L701 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M704 351L705 352L704 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M723 351L724 352L723 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M726 351L727 352L726 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M727 351L726 353L728 353L727 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M728 351L729 352L728 351M730 351L731 352L730 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M737 351L738 352L737 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M746 351L747 352L746 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M753 351L754 352L753 351M755 351L756 352L755 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M756 351L756 353L758 353L756 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M760 351L761 352L760 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M768 351L769 352L768 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M769 351L770 352L769 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M773 351L774 352L773 351M526 352L526 356L527 356L526 352M532 352L532 357L533 357L532 352M542 352L542 355L543 355L542 352M566 352L567 353L566 352M569 352L570 353L569 352M578 352L579 353L578 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M580.333 352.667L580.667 353.333L580.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M583.333 352.667L583.667 353.333L583.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M596 352L596 357L597 357L596 352M625 352L626 353L625 352M632 352L632 357L633 357L632 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M647 352L648 353L647 352M649 352L650 353L649 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M652 352L651 354L653 354L652 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M654 352L655 353L654 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M667 352L670 354L667 352M687 352L688 353L687 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M689 352L690 353L689 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M694.333 352.667L694.667 353.333L694.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M697 352L698 353L697 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M699 352L699 353L703 353L703 352L699 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M704 352L705 353L704 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M709 352L711 354L709 352M712 352L713 353L712 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M723 352L724 353L723 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M725.333 352.667L725.667 353.333L725.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M728 352L726 353L726 354L728 352M737 352L738 353L737 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M740 354L744 353L740 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M744 352L745 353L744 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M755 352L758 354L758 353L755 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M758.333 352.667L758.667 353.333L758.333 352.667M760.333 352.667L760.667 353.333L760.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M770 352L771 353L770 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M771 352L772 353L771 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M774 352L775 353L774 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M782 352C783.223 355.687 785.308 355.88 789 356L789 355L782 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M567 353L568 354L567 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M578 353L579 354L578 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M581 353L582 354L581 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M582 353L583 354L582 353M586 353L587 354L586 353M612 353L613 354L612 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M615 353L616 354L615 353M622 353L623 354L622 353M625 353L626 354L625 353M635 353L636 354L635 353M646 353L647 354L646 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M649 353L650 354L649 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M650 353L651 354L650 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M655 353L656 354L655 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M665 353L666 354L665 353M671 353L672 354L671 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M689 353L690 354L689 353M691 353L692 354L691 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M696 353L697 354L696 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M699 353L700 354L699 353M702 353L703 354L702 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M705 353L706 354L705 353M707 353L708 354L707 353M722 353L723 354L722 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M731 353L732 354L731 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M737 353L737 358L738 358L737 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M740 354L740 355L745 354L740 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M747.333 353.667L747.667 354.333L747.333 353.667M752 353L753 354L752 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M772 353L773 354L772 353M774 353L774 356L775 356L774 353M568 354L569 355L568 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M577 354L578 355L577 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M586 354L587 355L586 354M613 354L614 355L613 354M615 354L616 355L615 354M622 354L623 355L622 354M624 354L625 355L624 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M636 354L637 355L636 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M646 354L647 355L646 354M655 354L656 355L655 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M658 354L659 355L658 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M688 354L689 355L688 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M691 354L692 355L691 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M696 354L697 355L696 354M705 354L706 355L705 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M712 354L712 357L713 357L712 354M719 354L720 355L719 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M722 354L723 355L722 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M731 354L732 355L731 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M744 354L745 355L744 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M752 354L753 355L752 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M761 354L762 355L761 354M766 354L767 355L766 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M767 354L768 355L767 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M772 354L773 355L772 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M542 355L543 356L542 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M543 355L543 356L549 356L543 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M569 355L570 356L569 355M577 355L578 356L577 355M580 355L580 356L585 356L580 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M587 355L588 356L587 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M613 355L614 356L613 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M616 355L617 356L616 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M617 355L618 356L617 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M618.667 355.333L619.333 355.667L618.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M620 355L621 356L620 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M621 355L622 356L621 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M624 355L625 356L624 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M637 355L638 356L637 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M645 355L646 356L645 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M648 355L648 356L654 356L648 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M656 355L657 356L656 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M664.667 355.333L665.333 355.667L664.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M666 355L667 356L666 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M667.667 355.333L668.333 355.667L667.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M669 355L670 356L669 355M671 355L672 356L671 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M683 355L684 356L683 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M684 355L685 356L684 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M685.667 355.333L686.333 355.667L685.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M687 355L688 356L687 355M690 355L691 356L690 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M695 355L696 356L695 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M698 355L698 356L704 356L698 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M706 355L707 356L706 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M722 355L723 356L722 355M724 355L724 356L730 356L724 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M732 355L733 356L732 355M740.667 355.333L741.333 355.667L740.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M742 355L743 356L742 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M743 355L744 356L743 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M744 355L745 356L744 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M747 355L748 356L747 355M751 355L752 356L751 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M754 355L754 356L760 356L754 355M761 355L762 356L761 355M766 355L768 357L766 355M768 355L769 356L768 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M769 355L769 356L772 356L769 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M772 355L773 356L772 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M782 355L783 356L782 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M570 356L571 357L570 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M576.333 356.667L576.667 357.333L576.333 356.667M579 356L580 357L579 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M585 356L585 357L588 358L588 357L588 356L585 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M614 356L615 357L614 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M622 356L623 357L622 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M623 356L624 357L623 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M638 356L639 357L638 356M645.333 356.667L645.667 357.333L645.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M648 356L649 357L648 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M656 356L655 358L657 358L656 356M669 356L662 357L662 358L670 357L669 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M672 356L669 363L676 361L676 360L675 358L672 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M689 356L690 357L689 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M690 357L690 358L694 358L690 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M695 356L696 357L695 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M698 356L699 357L698 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M704 356L704 357L707 358L707 357L707 356L704 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M718 356L719 357L718 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M721.333 356.667L721.667 357.333L721.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M724 356L725 357L724 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M730 356L730 357L733 358L733 357L733 356L730 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M746 356L747 357L746 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M751 356L751 357L751 358L754 357L754 356L751 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M759 356L760 357L759 356M762 356L763 357L762 356M766 356L767 357L766 356M774 356L775 357L774 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M788 356L780 357L780 358L789 357L788 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M513 357L514 358L513 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M515 357L516 358L515 357M524 357L525 358L524 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M526 357L527 358L526 357M532 357L533 358L532 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M534 357L535 358L534 357M540 357L541 358L540 357M548 357L549 358L548 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M562.667 357.333L563.333 357.667L562.667 357.333M571 357L572 358L571 357M577 357L578 358L577 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M578 357L579 358L578 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M585 357L586 358L585 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M594 357L595 358L594 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M596 357L597 358L596 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M605 357L606 358L605 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M607 357L608 358L607 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M616 357L617 358L616 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M617 357L618 358L617 357M619.667 357.333L620.333 357.667L619.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M621 357L622 358L621 357M630 357L631 358L630 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M632 357L633 358L632 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M639 357L640 358L639 357M646 357L647 358L646 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M647 357L648 358L647 357M654 357L655 358L654 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M661 357L662 358L661 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M669 357L670 358L669 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M680 357L681 358L680 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M681 357L681 358L687 358L681 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M687 357L688 358L687 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M688 357L689 358L688 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M692 357L693 358L692 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695.667 357.333L696.333 357.667L695.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M697 357L698 358L697 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M701 357L701 360L702 360L701 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M704 357L705 358L704 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M713.667 357.333L714.333 357.667L713.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M715 357L716 358L715 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M722.667 357.333L723.333 357.667L722.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M726 357L727 358L726 357M730 357L731 358L730 357M733 357L734 358L733 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M738 357L738 358L744 358L738 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M744 357L745 358L744 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M745 357L746 358L745 357M748 357L749 358L748 357M753 357L754 358L753 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M760 357L761 358L760 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M761 357L762 358L761 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M762 357L763 358L762 357M768 357L769 358L768 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M769 357L770 358L769 357M771.667 357.333L772.333 357.667L771.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M773 357L774 358L773 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M788 357L789 358L788 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M651 358L652 359L651 358M656 358L657 359L656 358M660 358L659 360L661 360L660 358M720 358L721 359L720 358M729 358L730 359L729 358M754 358L755 359L754 358M657 359L658 360L657 359M662 359L663 360L662 359M667 359L668 360L667 359M681 359L681 360L684 360L681 359M685 359L686 360L685 359M688.333 359.667L688.667 360.333L688.333 359.667M691 359L692 360L691 359M694 359L694 360L697 360L694 359M698 359L699 360L698 359M722 359L723 360L722 359M731 359L732 360L731 359M735 359L736 360L735 359M739.667 359.333L740.333 359.667L739.667 359.333M752 359L753 360L752 359M887 359L889 361L887 359M679.333 360.667L679.667 361.333L679.333 360.667M690 360L691 361L690 360M673.667 362.333L674.333 362.667L673.667 362.333M894.667 365.333L895.333 365.667L894.667 365.333M898 367L900 369L898 367M903 372L906 374L906 373L903 372M757 376L762 382L760 376L757 376M767.333 379.667L767.667 380.333L767.333 379.667M761 383L762 384L761 383M763 383L764 384L763 383M845 383L846 384L845 383M767 384L768 385L767 384M848 384L846 385L846 389C848.461 387.547 849.317 386.631 848 384M915.333 384.667L915.667 385.333L915.333 384.667M427 387L428 388L427 387M767.333 387.667L767.667 388.333L767.333 387.667M771 388L770 392L771 388M775 389L773 392C775.251 391.527 776.118 391.14 775 389M424 391L423 393L424 391M767 391L768 392L767 391M852 392L856 396L856 392L852 392M860 414L861 415L860 414M784 416L784 418L786 416L784 416M543 419L544 420L543 419M859 419L862 424L859 419M794 420L794 432L797 427L793 430L797 424L800 440L803 440C802.82 436.438 802.869 432.825 799 432C799.807 428.451 800.223 426.096 797 424L794 420M545.333 421.667L545.667 422.333L545.333 421.667M550.333 421.667L550.667 422.333L550.333 421.667M542.333 422.667L542.667 423.333L542.333 422.667M547.667 423.333L548.333 423.667L547.667 423.333M564 424L565 425L564 424M860 426L859 440L862 440L859 448L859 449C867.131 447.643 862.871 431.4 860 426M559 427L560 428L559 427M554.667 428.333L555.333 428.667L554.667 428.333M551.667 430.333L552.333 430.667L551.667 430.333M555 433L558 432L555 433M552 432L553 433L552 432M553 439L554 440L553 439M782 440L782 441L785 441L782 440M795 440L796 441L795 440M807 440L807 444L808 444L807 440M543 441L544 442L543 441M779 441L780 442L779 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M780 441L781 442L780 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M781.015 441.758C770.334 445.642 776.299 461.433 786.982 457.396C797.286 453.501 790.968 438.139 781.015 441.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786 441L787 442L786 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M787 441L788 442L787 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M788 441L789 442L788 441M797 441L799 443L799 447L800 447L797 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M778 442L779 443L778 442M788 442L789 443L788 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789 442L790 443L789 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M777 443L778 444L777 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M790 443L791 444L790 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M776 444L777 445L776 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M791 444L792 445L791 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M775 445L776 446L775 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M795 445L796 446L795 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M775 446L776 447L775 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M792 446L793 447L792 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M774 447L775 448L774 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M792 447L793 448L792 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M774 448L774 452L775 452L774 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M799 448L800 449L799 448M801.333 448.667L801.667 449.333L801.333 448.667M805 448L806 453L805 453L802 451L802 455L810 454L809 451L808 451L807 455L806 455L805 448M808.333 448.667L808.667 449.333L808.333 448.667M496 449L497 450L496 449M793 449L794 450L793 449M503.333 450.667L503.667 451.333L503.333 450.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M240 451L241 452L240 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M255 491L285 491L285 490C279.158 490 258.788 486.856 255.028 491.603C250.971 496.725 254 513.551 254 520L241 520L241 452L254 452L254 477C256.027 472.169 256.771 458.142 254.397 453.318C252.644 449.755 242.356 449.755 240.603 453.318C238.732 457.122 240 463.845 240 468L240 504C240 507.929 238.456 516.15 241.028 519.397C243.234 522.183 252.754 522.021 254.397 518.682C257.669 512.031 255 498.392 255 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M254 451L255 452L254 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M285 451L285 452L299 452L285 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M299 451L300 452L299 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M630 451L631 452L630 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M630 493L631 493L631 452L645 452C622.871 442.714 630 480.499 630 493M792.333 451.667L792.667 452.333L792.333 451.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M858 452L863 461L862 456L864 452L858 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M241 452L241 520L254 520C254 513.702 250.971 496.236 255.603 491.603C260.342 486.865 278.54 490 285 490L285 520L299 520L299 452L285 452L286 477C280.273 478.363 258.699 481.184 255.028 475.682C251.609 470.558 254 458.033 254 452L241 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M299 452L299 521L300 521L300 474L299 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M509 452L510 453L509 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M631 452L631 520L644 520C644 498.64 640.053 472.777 645 452L631 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M774 452L775 453L774 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M803 452L804 453L803 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M499 453L500 454L499 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M644 453L644 520L631 520L631 521L645 521L645 474L644 453M775 453L776 454L775 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M792 453L793 454L792 453M775 454L776 455L775 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M791 454L792 455L791 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M496 455L496 468L497 468L496 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M497 455L498 456L497 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M498 455L498 456L511 456L498 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M511 455L512 456L511 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M776 455L777 456L776 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M790 455L791 456L790 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M807 455L808 456L807 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M807 469L808 469L808 456L821 456C808.802 450.881 807 459.164 807 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M821 455L822 456L821 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M497 456L497 469L489 469L489 480L497 480C497 492.038 493.026 513.733 507.004 519.517C513.093 522.037 520.549 521 527 521L527 509C507.53 509 511 495.7 511 480L526 480L526 469L511 469L511 456L497 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M511 456C511 468.721 513.864 469 526 469L526 468L512 468L511 456M777 456L778 457L777 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M789 456L790 457L789 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M808 456L808 469L800 469L800 480C803.868 480.126 807.131 480.585 807.852 485.019C809.44 494.787 805.088 506.316 811.649 514.906C815.346 519.746 832.143 525.494 836.972 519.397C838.911 516.949 838 511.927 838 509C818.428 509 822 495.784 822 480L836 480L836 469L822 469L822 456L808 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M778 457L779 458L778 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M779 457L780 458L779 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M788 457L789 458L788 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M780 458L781 459L780 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M781 458L782 459L781 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M782 458L782 459L786 459L782 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M786 458L787 459L786 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M805 464L806 465L805 464M860 464L861 465L860 464M863 464L860 466L860 467L864 467L863 464M333 467L334 468L333 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M334 467L335 468L334 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M335 467L335 468L342 468L335 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M342 467L343 468L342 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M343.667 467.333L344.333 467.667L343.667 467.333M410 467L411 468L410 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M411 467L411 468L415 468L411 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M415 467L416 468L415 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M555.667 467.333L556.333 467.667L555.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M557.667 467.333L558.333 467.667L557.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M559 467L559 468L565 468L559 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M565 467L566 468L565 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M566.667 467.333L567.333 467.667L566.667 467.333M682 467L683 468L682 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M683.667 467.333L684.333 467.667L683.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M685 467L685 468L690 468L685 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M690 467L691 468L690 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M691.667 467.333L692.333 467.667L691.667 467.333M865.667 467.333L866.333 467.667L865.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M867.667 467.333L868.333 467.667L867.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M869 467L869 468L874 468L869 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M874.667 467.333L875.333 467.667L874.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M876 467L877 468L876 467M951.667 467.333L952.333 467.667L951.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M953.667 467.333L954.333 467.667L953.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M955 467L955 468L958 468L955 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M958 467L958 468L962 468L958 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1017 467L1018 468L1017 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1018 467L1019 468L1018 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1019 467L1019 468L1024 468L1019 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1024 467L1025 468L1024 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1025 467L1026 468L1025 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M329 468L330 469L329 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M330 468L331 469L330 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M331 468.529C295.989 476.609 311.552 528.378 346 520.471C381.113 512.41 365.322 460.609 331 468.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M346 468L347 469L346 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M347 468L348 469L347 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M369 468L370 469L369 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M369 469L369 470L384 469L369 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M384 468L385 469L384 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M410 468L397 498L383.582 470.028L370 469C373.908 482.565 381.601 496.275 387.742 509C389.393 512.423 391.164 520.704 396 520.704C399.523 520.704 400.844 516.645 402 513.999C405.204 506.669 409.783 499.697 412 492L414 492L424.248 513.999L430.83 520.534L438.255 509L456 469C452.132 469 445.78 467.804 442.418 470.028C436.392 474.014 432.59 490.325 430 497C425.229 488.826 420.501 468.349 410 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M441 468L442 469L441 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M442 468L442 469L457 470L442 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M456 468L457 469L456 468M488 468L489 469L488 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M489 468L489 469L495 469L489 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M495.667 468.333L496.333 468.667L495.667 468.333M511 468L512 469L511 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M551 468L552 469L551 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M552 468L553 469L552 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M553 468L554 469L553 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M554 468.529C518.985 476.61 534.625 528.362 569 520.471C604.113 512.41 588.323 460.609 554 468.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M569 468L570 469L569 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M570 468L571 469L570 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M571 468L572 469L571 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M659 468L659 469L672 469L659 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M678 468L679 469L678 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M679 468L680 469L679 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M680 468L681 469L680 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M672 473L672 469L659 469L659 520L673 520C673 511.076 668.046 476.679 684.996 480.616C697.812 483.592 693 510.353 693 520L706 520C706 501.048 712.659 462.846 682 468.329C678.248 469 675.135 470.952 672 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M693 468L694 469L693 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M694 468L695 469L694 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M695 468L696 469L695 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M712 470L727 469C723.12 467.372 714.931 466.646 712 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M727 468L728 469L727 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M753 468L753 469L768 469L753 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M768.333 468.667L768.667 469.333L768.333 468.667M776 468L777 469L776 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M776 520L777 520L777 469L791 469C787.877 467.69 779.478 466.51 777.028 469.603C774.699 472.543 776 479.469 776 483L776 520M799 468L799 469L807 469L799 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M822 468L823 469L822 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M823 468L823 469L836 469L823 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M836 468L837 469L836 468M861 468L862 469L861 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M862 468L863 469L862 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M863 468L864 469L863 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M893 515L888 505C877.118 508.953 864.12 514.051 859 499L895 499C895.659 490.651 896.136 483.057 890.468 476.043C880.361 463.537 859.125 465.946 849.928 478.039C839.436 491.836 845.329 514.121 862 519.891C872.759 523.615 883.533 519.98 893 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M878.667 468.333L879.333 468.667L878.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M880 468L881 469L880 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M948 468L949 469L948 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M949.667 468.333L950.333 468.667L949.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M935 478L935 479L941 486C950.484 482.358 964.264 474.17 966 491C957.055 491 944.276 489.743 937.225 496.39C929.928 503.269 933.143 516.02 942.004 519.772C950.439 523.343 959.69 520.355 967 516L967 520L979 520C979 508.051 982.015 491.284 977.867 480C970.898 461.044 945.882 467.374 935 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M964 468L965 469L964 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M965 468L966 469L965 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M966 468L967 469L966 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M993 468L993 469L1007 470L993 468M1013 468L1014 469L1013 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1014 468L1015 469L1014 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1006 473L1006 469L993 469L993 520L1007 520C1007 510.313 1004.71 497.266 1007.65 488.004C1009.22 483.068 1014.68 478.86 1020 480.758C1031.72 484.945 1027 510.192 1027 520L1041 520C1041 500.863 1046.69 462.802 1016 468.329C1012.26 469.004 1009.21 471.09 1006 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1027 468L1028 469L1027 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1028 468L1029 469L1028 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M326 469L327 470L326 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M327 469L328 470L327 469M349 469L350 470L349 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M350 469L351 470L350 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M384 469L385 470L384 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M409 469L410 470L409 469M416 469L417 470L416 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M441 469L442 470L441 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M488 469L488 480L489 480L488 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M526 469L526 474L527 474L526 469M549 469L550 470L549 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M550 469L551 470L550 469M572 469L573 470L572 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M573 469L574 470L573 469M672 469L674 472L672 469M676 469L677 470L676 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M677 469L678 470L677 469M696 469L697 470L696 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M697 469L698 470L697 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M713 469C718.288 482.63 725.307 495.882 731.756 509C733.425 512.395 736.009 521.089 740.938 520.534C745.634 520.005 747.856 511.593 749.424 508C755.183 494.803 762.46 482.306 768 469C764.08 469 758.005 467.854 754.418 469.603C748.336 472.569 742.731 491.672 741 498L726.61 470.028L713 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M727 469L728 470L727 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M752 469L753 470L752 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M777 469L777 520L791 520L791 469L777 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M799 469C799 476.38 798.441 480.899 807 481L807 480L800 480L799 469M836 469L836 480L822 480L822 481C830.743 481 841.056 481.05 836 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M859 469L860 470L859 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M860 469L861 470L860 469M881 469L882 470L881 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M882 469L883 470L882 469M945 469L946 470L945 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M946 469L947 470L946 469M967 469L968 470L967 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M968 469L969 470L968 469M1011 469L1012 470L1011 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1030 469L1031 470L1030 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1031 469L1032 470L1031 469M324 470L325 471L324 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M325 470L326 471L325 470M351 470L352 471L351 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M352 470L353 471L352 470M385 470L386 471L385 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M409 470L410 471L409 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M440 470L441 471L440 470M547 470L548 471L547 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M548 470L549 471L548 470M574 470L575 471L574 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M575 470L576 471L575 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M675 470L676 471L675 470M698 470L699 471L698 470M713 470L714 471L713 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M728 470L729 471L728 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M752 470L753 471L752 470M767 470L768 471L767 470M858 470L859 471L858 470M883 470L884 471L883 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M884 470L885 471L884 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M943 470L944 471L943 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M944 470L945 471L944 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M970 470L971 471L970 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1006.33 470.667L1006.67 471.333L1006.33 470.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1009 470L1010 471L1009 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1032 470L1033 471L1032 470M323 471L324 472L323 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M353 471L354 472L353 471M370 471L371 472L370 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M385 471L386 472L385 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M408 471L409 472L408 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M417 471L418 472L417 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M440 471L441 472L440 471M455 471L456 472L455 471M546 471L547 472L546 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M576 471L577 472L576 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M674 471L675 472L674 471M699 471L700 472L699 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M700 471L701 472L700 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M713 471L714 472L713 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M728 471L729 472L728 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M767 471L768 472L767 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M856 471L857 472L856 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M885 471L886 472L885 471M942 471L943 472L942 471M971 471L972 472L971 471M1008 471L1009 472L1008 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1034 471L1035 472L1034 471M321 472L322 473L321 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M322 472L323 473L322 472M354 472L355 473L354 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M355 472L356 473L355 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M408 472L409 473L408 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M455 472L456 473L455 472M544 472L545 473L544 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M545 472L546 473L545 472M577 472L578 473L577 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M578 472L579 473L578 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M672 472L673 473L672 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M701 472L702 473L701 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M714 472L715 473L714 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M729 472L730 473L729 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M751 472L752 473L751 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M766 472L767 473L766 472M855 472L856 473L855 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M887 472L888 473L887 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M940 472L941 473L940 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M973 472L974 473L973 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1006 472L1007 473L1006 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1007 472L1008 473L1007 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1035 472L1036 473L1035 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M320 473L321 474L320 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M356 473L357 474L356 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M371 473L372 474L371 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M386 473L387 474L386 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M407 473L408 474L407 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M418 473L419 474L418 473M439 473L440 474L439 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M454 473L455 474L454 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M543 473L544 474L543 473M579 473L580 474L579 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M702 473L703 474L702 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M714 473L715 474L714 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M729 473L730 474L729 473M751 473L752 474L751 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M766 473L767 474L766 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M854 473L855 474L854 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M888 473L889 474L888 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M939 473L940 474L939 473M319 474L320 475L319 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M357 474L358 475L357 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M371 474L372 475L371 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M386 474L387 475L386 474M407 474L408 475L407 474M418 474L419 475L418 474M439 474L440 475L439 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M454 474L455 475L454 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M542 474L543 475L542 474M580 474L581 475L580 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M702 474L703 475L702 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M750 474L751 475L750 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M765 474L766 475L765 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M852 474L853 475L852 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M889 474L890 475L889 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M938 474L939 475L938 474M318 475L319 476L318 475M358 475L359 476L358 475M372 475L373 476L372 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M387 475L388 476L387 475M406 475L407 476L406 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M419 475L420 476L419 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M438 475L439 476L438 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M453 475L454 476L453 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M541 475L542 476L541 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M581 475L582 476L581 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M703 475L704 476L703 475M715 475L716 476L715 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M730 475L731 476L730 475M750 475L751 476L750 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M765 475L766 476L765 475M851 475L852 476L851 475M890 475L891 476L890 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M937 475L938 476L937 475M975 475L976 476L975 475M1037 475L1038 476L1037 475M285 476L286 477L285 476M317 476L318 477L317 476M359 476L360 477L359 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M372 476L373 477L372 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M387 476L388 477L387 476M406 476L407 477L406 476M419 476L420 477L419 476M438 476L439 477L438 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M453 476L454 477L453 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M540 476L541 477L540 476M582 476L583 477L582 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M704 476L705 477L704 476M749 476L750 477L749 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M764 476L765 477L764 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M850 476L851 477L850 476M891 476L892 477L891 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M936 476L937 477L936 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M976 476L977 477L976 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1038 476L1039 477L1038 476M255.667 477.333L256.333 477.667L255.667 477.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M257 477L257 478L270 478L257 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M270 477L270 478L284 478L270 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M284 477L285 478L284 477M316 477L317 478L316 477M360 477L361 478L360 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M373 477L374 478L373 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M388 477L389 478L388 477M405 477L406 478L405 477M420 477L421 478L420 477M437 477L438 478L437 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M452 477L453 478L452 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M539 477L540 478L539 477M583 477L584 478L583 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M704 477L705 478L704 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M716 477L717 478L716 477M731 477L732 478L731 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M749 477L750 478L749 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M764 477L765 478L764 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M850 477L851 478L850 477M891 477L892 478L891 477M935 477L936 478L935 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M977 477L978 478L977 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1038 477L1039 478L1038 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M315 478L316 479L315 478M361 478L362 479L361 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M373 478L374 479L373 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M388 478L389 479L388 478M405 478L406 479L405 478M420 478L421 479L420 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M437 478L438 479L437 478M452 478L453 479L452 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M538 478L539 479L538 478M584 478L585 479L584 478M705 478L706 479L705 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M731 478L732 479L731 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M748 478L749 479L748 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M763 478L764 479L763 478M849 478L850 479L849 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M892 478L893 479L892 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M934 478L935 479L934 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M977 478L978 479L977 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1039 478L1040 479L1039 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M374 479L375 480L374 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M421 479L422 480L421 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M437 479L438 480L437 479M538 479L539 480L538 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M705 479L706 480L705 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M717 479L718 480L717 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M732 479L733 480L732 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M748 479L749 480L748 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M763 479L764 480L763 479M848 479L849 480L848 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M867 479L868 480L867 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M868 479L869 480L868 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M869 479L870 480L869 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M860 489L882 489C878.129 477.954 862.662 475.844 860 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M871.667 479.333L872.333 479.667L871.667 479.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M873 479L874 480L873 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M874 479L875 480L874 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M893 479L894 480L893 479M935 479L936 480L935 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1039 479L1040 480L1039 479M314 480L315 481L314 480M335 480L335 481L342 481L335 480M362 480L363 481L362 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M374 480L375 481L374 480M389 480L390 481L389 480M404 480L405 481L404 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M421 480L422 481L421 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M436 480L437 481L436 480M451 480L452 481L451 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M488 480L489 481L488 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M489 480L489 481L497 481L489 480M511 480L511 481L526 481L511 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M526 480L527 481L526 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M537 480L538 481L537 480M559 480L559 481L564 481L559 480M585 480L586 481L585 480M680 480L681 481L680 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M681 480L681 481L685 481L681 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M685 480L686 481L685 480M705 480L706 481L705 480M732 480L733 481L732 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M799 480L800 481L799 480M836 480L837 481L836 480M865 480L866 481L865 480M876 480L877 481L876 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M893 480L894 481L893 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M936 480L937 481L936 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M951 480L952 481L951 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M952.667 480.333L953.333 480.667L952.667 480.333M958 480L959 481L958 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M959 480L960 481L959 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M960 480L961 481L960 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M978 480L979 481L978 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1014 480L1015 481L1014 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1015 480L1015 481L1019 481L1015 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1019.67 480.333L1020.33 480.667L1019.67 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M313 481L314 482L313 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M333 481L334 482L333 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M334 481L335 482L334 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M335.004 481.559C319.483 485.604 325.21 512.225 342 507.427C357.558 502.982 351.265 477.32 335.004 481.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M342 481L343 482L342 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M343 481L344 482L343 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M363 481L364 482L363 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M389 481L390 482L389 481M404 481L405 482L404 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M422 481L423 482L422 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M436 481L437 482L436 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M496 481L496 504L497 504L496 481M511.333 481.667L511.667 482.333L511.333 481.667M536 481L537 482L536 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M556 481L557 482L556 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M557 481L558 482L557 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M558.004 481.559C542.286 485.656 548.32 511.757 564.996 507.581C580.723 503.642 574.351 477.298 558.004 481.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M565 481L566 482L565 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M566 481L567 482L566 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M586 481L587 482L586 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M678 481L679 482L678 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M679 481L680 482L679 481M686 481L687 482L686 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M687 481L688 482L687 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M688 481L689 482L688 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M706.333 481.667L706.667 482.333L706.333 481.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M718 481L719 482L718 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M733 481L734 482L733 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M747 481L748 482L747 481M762 481L763 482L762 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M807 481L807 502L808 502L807 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M822 481L823 482L822 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M847 481L848 482L847 481M863 481L864 482L863 481M878 481L879 482L878 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M894 481L895 482L894 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M937 481L938 482L937 481M948 481L949 482L948 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M949 481L950 482L949 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M961 481L962 482L961 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M978 481L979 482L978 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1012 481L1013 482L1012 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1021 481L1022 482L1021 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1022 481L1023 482L1022 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1040 481L1041 482L1040 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M313 482L314 483L313 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M331 482L332 483L331 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M345 482L346 483L345 482M363 482L364 483L363 482M375 482L376 483L375 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M390 482L391 483L390 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M403 482L404 483L403 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M422 482L423 483L422 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M435 482L436 483L435 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M450 482L451 483L450 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M526 482L527 483L526 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M536 482L537 483L536 482M554 482L555 483L554 482M568 482L569 483L568 482M586 482L587 483L586 482M676 482L677 483L676 482M689 482L690 483L689 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M718 482L719 483L718 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M733 482L734 483L733 482M747 482L748 483L747 482M862 482L863 483L862 482M879 482L880 483L879 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M894 482L895 483L894 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M938 482L939 483L938 482M947 482L948 483L947 482M963 482L964 483L963 482M1010 482L1011 483L1010 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1023 482L1024 483L1023 482M1040 482L1041 483L1040 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M312 483L313 484L312 483M330 483L331 484L330 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M346 483L347 484L346 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M364 483L365 484L364 483M375 483L376 484L375 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M390 483L391 484L390 483M403 483L404 484L403 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M423 483L424 484L423 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M435 483L436 484L435 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M450 483L451 484L450 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M511 483L511 486L512 486L511 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M535 483L536 484L535 483M553 483L554 484L553 483M569 483L570 484L569 483M587 483L588 484L587 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M675 483L676 484L675 483M690 483L691 484L690 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M706 483L707 484L706 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M719 483L720 484L719 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M746 483L747 484L746 483M761 483L762 484L761 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M846 483L847 484L846 483M861 483L862 484L861 483M880 483L881 484L880 483M894 483L895 484L894 483M939 483L940 484L939 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M946 483L947 484L946 483M979 483L980 484L979 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1009 483L1010 484L1009 483M1024 483L1025 484L1024 483M1040 483L1040 486L1041 486L1040 483M312 484L313 485L312 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M347 484L348 485L347 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M364 484L365 485L364 484M376 484L377 485L376 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M391 484L392 485L391 484M402 484L403 485L402 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M423 484L424 485L423 484M449 484L450 485L449 484M535 484L536 485L535 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M570 484L571 485L570 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M587 484L588 485L587 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M690 484L691 485L690 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M706 484L706 520L693 520L693 487L692 487C692 494.196 688.532 513.72 693.028 519.397C695.514 522.535 705.461 521.964 706.682 517.852C708.911 510.344 708.994 491.136 706 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M719 484L720 485L719 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M734 484L735 485L734 484M746 484L747 485L746 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M880 484L881 485L880 484M895 484L896 485L895 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M944 484L945 485L944 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M945 484L946 485L945 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M964 484L965 485L964 484M979 484L980 485L979 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1009 484L1010 485L1009 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1025 484L1026 485L1025 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M328 485L329 486L328 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M348 485L349 486L348 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M365 485L366 486L365 485M376 485L377 486L376 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M391 485L392 486L391 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M402 485L403 486L402 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M434 485L435 486L434 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M449 485L450 486L449 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M551 485L552 486L551 485M571 485L572 486L571 485M674 485L675 486L674 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M691 485L692 486L691 485M720 485L721 486L720 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M745 485L746 486L745 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M760 485L761 486L760 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M822.333 485.667L822.667 486.333L822.333 485.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M845 485L846 486L845 485M860 485L861 486L860 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M881 485L882 486L881 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M895 485L896 486L895 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M940 485L941 486L940 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M943 485L944 486L943 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M964 485L965 486L964 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M979 485L979 520L967 520L967 521L978.397 519.972L980 511L979 485M1008 485L1009 486L1008 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1025 485L1026 486L1025 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M311 486L312 487L311 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M327 486L328 487L327 486M349 486L350 487L349 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M365 486L366 487L365 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M377 486L378 487L377 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M401 486L402 487L401 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M424 486L425 487L424 486M434 486L435 487L434 486M448 486L449 487L448 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M511 486L512 487L511 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M534 486L535 487L534 486M550 486L551 487L550 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M572 486L573 487L572 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M588 486L589 487L588 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M691 486L692 487L691 486M720 486L721 487L720 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M735 486L736 487L735 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M745 486L746 487L745 486M845 486L846 487L845 486M859 486L860 487L859 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M881 486L882 487L881 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M895.333 486.667L895.667 487.333L895.333 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M941 486L942 487L941 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M942 486L943 487L942 486M965 486L965 491L966 491L965 486M1026.33 486.667L1026.67 487.333L1026.33 486.667M311.333 487.667L311.667 488.333L311.333 487.667M365 487L366 488L365 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M377 487L378 488L377 487M392 487L393 488L392 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M401 487L402 488L401 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M425 487L426 488L425 487M433 487L434 488L433 487M448 487L449 488L448 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M511 487L511 496L512 496L511 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M534 487L535 488L534 487M588 487L589 488L588 487M673 487L674 488L673 487M721 487L722 488L721 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M744 487L745 488L744 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M759 487L760 488L759 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M859 487L860 488L859 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M881 487L882 488L881 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1007 487L1007 520L993 520L993 521L1006.4 519.972L1008 512L1007 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M326 488L327 489L326 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M350 488L351 489L350 488M378 488L379 489L378 488M392 488L393 489L392 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M400 488L401 489L400 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M425 488L426 489L425 488M433 488L434 489L433 488M447 488L448 489L447 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M549 488L550 489L549 488M573 488L574 489L573 488M673 488L673 520L674 520L673 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M721 488L722 489L721 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M736 488L737 489L736 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M744 488L745 489L744 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M844 488L845 489L844 488M859 488L860 489L859 488M1026 488L1026 521L1027 521L1026 488M326 489L327 490L326 489M350 489L351 490L350 489M366.333 489.667L366.667 490.333L366.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M378 489L379 490L378 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M393 489L394 490L393 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M400 489L401 490L400 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M432 489L433 490L432 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M447 489L448 490L447 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M573 489L574 490L573 489M589.333 489.667L589.667 490.333L589.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M722 489L723 490L722 489M736 489L737 490L736 489M758 489L759 490L758 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M844.333 489.667L844.667 490.333L844.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M859 489L859 490L882 490L859 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M310.333 490.667L310.667 491.333L310.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M325.333 490.667L325.667 491.333L325.333 490.667M351.333 490.667L351.667 491.333L351.333 490.667M379 490L380 491L379 490M393 490L394 491L393 490M426 490L427 491L426 490M432 490L433 491L432 490M446 490L447 491L446 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M533.333 490.667L533.667 491.333L533.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M548 490L549 491L548 490M574.333 490.667L574.667 491.333L574.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M722 490L723 491L722 490M737 490L738 491L737 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M743 490L744 491L743 490M366 491L366 498L367 498L366 491M379 491L380 492L379 491M399 491L400 492L399 491M446 491L447 492L446 491M548.333 491.667L548.667 492.333L548.333 491.667M589.333 491.667L589.667 492.333L589.333 491.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M723 491L724 492L723 491M737 491L738 492L737 491M757 491L758 492L757 491M844 491L844 499L845 499L844 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M945 491L946 492L945 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M946 491L947 492L946 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M947 491L947 492L952 492L947 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M310 492L310 498L311 498L310 492M325 492L326 493L325 492M351 492L351 497L352 497L351 492M394 492L395 493L394 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M412.667 492.333L413.333 492.667L412.667 492.333M427 492L428 493L427 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M431 492L432 493L431 492M533 492L533 496L534 496L533 492M574.333 492.667L574.667 493.333L574.333 492.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M723 492L724 493L723 492M738 492L739 493L738 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M742 492L743 493L742 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M757 492L758 493L757 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M942 492L943 493L942 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M943 492L944 493L943 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M325 493L325 496L326 496L325 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M380 493L381 494L380 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M394 493L395 494L394 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M398 493L399 494L398 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M412.667 493.333L413.333 493.667L412.667 493.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M431 493L432 494L431 493M445 493L446 494L445 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M548 493L548 496L549 496L548 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M589 493L590 494L589 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M630 493L630 496L631 496L630 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M724 493L725 494L724 493M738 493L739 494L738 493M742 493L743 494L742 493M756 493L757 494L756 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M940 493L941 494L940 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M941 493L942 494L941 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M380 494L381 495L380 494M395 494L396 495L395 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M411 494L412 495L411 494M414 494L415 495L414 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M428 494L429 495L428 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M430 494L431 495L430 494M574.333 494.667L574.667 495.333L574.333 494.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M589 494L589 498L590 498L589 494M724 494L725 495L724 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M741 494L742 495L741 494M756 494L757 495L756 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M895 494L895 497L896 497L895 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M938 494L939 495L938 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M939 494L940 495L939 494M381 495L382 496L381 495M395 495L396 496L395 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M397 495L398 496L397 495M411 495L412 496L411 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M414 495L415 496L414 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M430 495L431 496L430 495M444 495L445 496L444 495M725 495L726 496L725 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M739 495L740 496L739 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M741 495L742 496L741 495M755 495L756 496L755 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M937 495L938 496L937 495M325.333 496.667L325.667 497.333L325.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M381 496L382 497L381 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M397 496L398 497L397 496M410 496L411 497L410 496M415 496L416 497L415 496M429 496L430 497L429 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M511 496L511 502L512 502L511 496M533 496L533 499L534 499L533 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M548.333 496.667L548.667 497.333L548.333 496.667M574.333 496.667L574.667 497.333L574.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M630 496L630 501L631 501L630 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M725 496L726 497L725 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M740 496L741 497L740 496M755 496L756 497L755 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M936 496L937 497L936 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M351.333 497.667L351.667 498.333L351.333 497.667M382 497L383 498L382 497M396 497L397 498L396 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M410 497L411 498L410 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M415 497L416 498L415 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M443 497L444 498L443 497M726 497L727 498L726 497M740 497L741 498L740 497M754 497L755 498L754 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M822.333 497.667L822.667 498.333L822.333 497.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M895.333 497.667L895.667 498.333L895.333 497.667M935 497L936 498L935 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M310.333 498.667L310.667 499.333L310.333 498.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M325 498L326 499L325 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M366.333 498.667L366.667 499.333L366.333 498.667M382 498L383 499L382 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M409 498L410 499L409 498M416 498L417 499L416 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M443 498L444 499L443 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M548 498L549 499L548 498M574 498L575 499L574 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M589.333 498.667L589.667 499.333L589.333 498.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M726 498L727 499L726 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M754 498L755 499L754 498M350 499L351 500L350 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M383 499L384 500L383 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M409 499L410 500L409 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M416 499L417 500L416 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M442 499L443 500L442 499M727 499L728 500L727 499M753 499L754 500L753 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M844 499L845 500L844 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M859 499L859 500L895 500C885.44 495.989 869.387 499 859 499M934 499L935 500L934 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M326 500L327 501L326 500M350 500L351 501L350 500M383 500L384 501L383 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M408 500L409 501L408 500M417 500L418 501L417 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M442 500L443 501L442 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M534.333 500.667L534.667 501.333L534.333 500.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M549 500L550 501L549 500M573 500L574 501L573 500M727 500L728 501L727 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M753 500L754 501L753 500M844 500L845 501L844 500M859 500L860 501L859 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M952 500L952 501C956.57 501 962.261 499.776 965 504C966.287 498.269 955.571 500 952 500M311 501L312 502L311 501M326 501L327 502L326 501M350 501L351 502L350 501M365 501L366 502L365 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M408 501L409 502L408 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M417 501L418 502L417 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M441 501L442 502L441 501M549 501L550 502L549 501M573 501L574 502L573 501M588 501L589 502L588 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M630 501L630 520L631 520L630 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M728 501L729 502L728 501M752 501L753 502L752 501M859 501L860 502L859 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M933 501L934 502L933 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M949 501L947 504L949 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M950 501L951 502L950 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M965 501L957 501.004C940.04 501.241 954.922 518.161 963.142 506.791C964.41 505.036 964.671 503.065 965 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M311 502L312 503L311 502M327 502L328 503L327 502M349 502L350 503L349 502M365 502L366 503L365 502M384 502L385 503L384 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M407 502L408 503L407 502M418 502L419 503L418 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M441 502L442 503L441 502M511 502L512 503L511 502M534 502L535 503L534 502M550 502L551 503L550 502M572 502L573 503L572 502M588 502L589 503L588 502M728 502L729 503L728 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M752 502L753 503L752 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M807 502L807 506L808 506L807 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M822.333 502.667L822.667 503.333L822.333 502.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M845 502L846 503L845 502M933 502L934 503L933 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M311 503L312 504L311 503M348 503L349 504L348 503M365 503L366 504L365 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M407 503L408 504L407 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M418 503L419 504L418 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M511.333 503.667L511.667 504.333L511.333 503.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M571 503L572 504L571 503M588 503L589 504L588 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M751 503L752 504L751 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M845 503L846 504L845 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M860 503L861 504L860 503M312 504L313 505L312 504M328 504L329 505L328 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M347 504L348 505L347 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M364 504L365 505L364 504M385 504L386 505L385 504M406 504L407 505L406 504M419 504L420 505L419 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M440 504L441 505L440 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M535 504L536 505L535 504M551 504L552 505L551 504M587 504L588 505L587 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M729 504L730 505L729 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M751 504L752 505L751 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M822 504L823 505L822 504M861 504L862 505L861 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M887 504L888 505L887 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M947 504L947 507L948 507L947 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M964 504L965 505L964 504M312 505L313 506L312 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M329 505L330 506L329 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M346 505L347 506L346 505M364 505L365 506L364 505M385 505L386 506L385 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M406 505L407 506L406 505M419 505L420 506L419 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M512 505L513 506L512 505M535 505L536 506L535 505M553 505L554 506L553 505M569 505L570 506L569 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M587 505L588 506L587 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M729 505L730 506L729 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M750 505L751 506L750 505M822 505L823 506L822 505M846 505L847 506L846 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M862 505L863 506L862 505M885 505L886 506L885 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M888 505L889 506L888 505M964 505L965 506L964 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M313 506L314 507L313 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M331 506L332 507L331 506M345 506L346 507L345 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M363 506L364 507L363 506M386 506L387 507L386 506M405 506L406 507L405 506M420 506L421 507L420 506M439 506L440 507L439 506M497.333 506.667L497.667 507.333L497.333 506.667M512 506L513 507L512 506M536 506L537 507L536 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M554 506L555 507L554 506M568 506L569 507L568 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M586 506L587 507L586 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M730 506L731 507L730 506M750 506L751 507L750 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M807 506L808 507L807 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M823 506L824 507L823 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M846 506L847 507L846 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M863 506L864 507L863 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M883 506L884 507L883 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M884 506L885 507L884 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M889 506L890 507L889 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M313 507L314 508L313 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M332 507L333 508L332 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M333 507L334 508L333 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M342 507L343 508L342 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M343 507L344 508L343 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M363 507L364 508L363 507M386 507L387 508L386 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M405 507L406 508L405 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M420 507L421 508L420 507M439 507L440 508L439 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 507L514 508L513 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M514 507L515 508L514 507M536 507L537 508L536 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M555 507L556 508L555 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M556 507L557 508L556 507M566 507L567 508L566 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M567 507L568 508L567 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M586 507L587 508L586 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M749 507L750 508L749 507M824 507L825 508L824 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M825 507L826 508L825 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M847 507L848 508L847 507M864 507L865 508L864 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M865 507L866 508L865 507M881 507L882 508L881 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M882 507L883 508L882 507M889 507L890 508L889 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M932 507L933 508L932 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M947 507L948 508L947 507M963 507L964 508L963 507M314 508L315 509L314 508M335.667 508.333L336.333 508.667L335.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M337.667 508.333L338.333 508.667L337.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M339 508L339 509L342 509L339 508M362 508L363 509L362 508M387 508L388 509L387 508M404 508L405 509L404 508M421 508L422 509L421 508M438 508L439 509L438 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M497 508L498 509L497 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M515 508L516 509L515 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M516.667 508.333L517.333 508.667L516.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M519 508L519 509L526 509L519 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M526 508L527 509L526 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M527 508L528 509L527 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M537 508L538 509L537 508M558.667 508.333L559.333 508.667L558.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M560.667 508.333L561.333 508.667L560.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M562 508L562 509L565 509L562 508M585 508L586 509L585 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M731 508L732 509L731 508M749 508L750 509L749 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M808.333 508.667L808.667 509.333L808.333 508.667M826 508L827 509L826 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M827 508L828 509L827 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M828 508L828 509L836 509L828 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M836 508L836 509L838 511L839 511L836 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M838 508L839 509L838 508M847 508L848 509L847 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M866 508L867 509L866 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M867 508L868 509L867 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M868 508L869 509L868 508M878 508L879 509L878 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M879 508L880 509L879 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M880 508L881 509L880 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M890 508L891 509L890 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M948 508L949 509L948 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M962 508L963 509L962 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M387 509L388 510L387 509M404 509L405 510L404 509M421 509L422 510L421 509M438 509L439 510L438 509M497 509L498 510L497 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M527 509L527 520L528 520L527 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M585 509L586 510L585 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M848 509L849 510L848 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M869 509L869 510L872 510L869 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M872 509L873 510L872 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M873 509L873 510L877 510L873 509M890 509L891 510L890 509M933.333 509.667L933.667 510.333L933.333 509.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M949 509L950 510L949 509M960 509L961 510L960 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M961 509L962 510L961 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M315 510L316 511L315 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M361 510L362 511L361 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M388 510L389 511L388 510M403 510L404 511L403 510M422 510L423 511L422 510M437 510L438 511L437 510M498.333 510.667L498.667 511.333L498.333 510.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M538 510L539 511L538 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M584 510L585 511L584 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M732 510L733 511L732 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M748 510L749 511L748 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M808 510L809 511L808 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M849 510L850 511L849 510M891 510L892 511L891 510M950 510L951 511L950 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M951 510L952 511L951 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M958 510L959 511L958 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M959 510L960 511L959 510M316 511L317 512L316 511M360 511L361 512L360 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M388 511L389 512L388 511M403 511L404 512L403 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M422 511L423 512L422 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M437 511L438 512L437 511M539 511L540 512L539 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M583 511L584 512L583 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M732 511L733 512L732 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M809 511L810 512L809 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M838 511L838 521L839 521L838 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M850 511L851 512L850 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M933 511L934 512L933 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M953 511L953 512L957 512L953 511M317 512L318 513L317 512M359 512L360 513L359 512M389 512L390 513L389 512M402 512L403 513L402 512M423 512L424 513L423 512M436 512L437 513L436 512M540 512L541 513L540 512M582 512L583 513L582 512M733 512L734 513L733 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M747 512L748 513L747 512M809 512L810 513L809 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M850 512L851 513L850 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M892 512L893 513L892 512M318 513L319 514L318 513M358 513L359 514L358 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M389 513L390 514L389 513M402 513L403 514L402 513M423 513L424 514L423 513M436 513L437 514L436 513M499 513L500 514L499 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M541 513L542 514L541 513M581 513L582 514L581 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M733 513L734 514L733 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M810 513L811 514L810 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M851 513L852 514L851 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M893 513L894 514L893 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M934 513L935 514L934 513M319 514L320 515L319 514M357 514L358 515L357 514M424 514L425 515L424 514M500 514L501 515L500 514M542 514L543 515L542 514M580 514L581 515L580 514M734 514L735 515L734 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M746 514L747 515L746 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M810 514L811 515L810 514M852 514L853 515L852 514M893 514L894 515L893 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M935 514L936 515L935 514M320 515L321 516L320 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M356 515L357 516L356 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M390 515L391 516L390 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M401 515L402 516L401 515M424 515L425 516L424 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M435 515L436 516L435 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M500 515L501 516L500 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M543 515L544 516L543 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M579 515L580 516L579 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M734 515L735 516L734 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M811 515L812 516L811 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M854 515L855 516L854 515M891 515L892 516L891 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M935 515L936 516L935 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M321 516L322 517L321 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M355 516L356 517L355 516M390 516L391 517L390 516M401 516L402 517L401 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M425 516L426 517L425 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M501 516L502 517L501 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M544 516L545 517L544 516M578 516L579 517L578 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M735 516L736 517L735 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M745 516L746 517L745 516M812 516L813 517L812 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M855 516L856 517L855 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M890 516L891 517L890 516M936 516L937 517L936 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M965.667 516.333L966.333 516.667L965.667 516.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M318 517L319 518L318 517M322 517L323 518L322 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M323 517L324 518L323 517M353 517L354 518L353 517M391 517L392 518L391 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M400 517L401 518L400 517M425 517L426 518L425 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M434 517L435 518L434 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M502 517L503 518L502 517M545 517L546 518L545 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M546 517L547 518L546 517M576 517L577 518L576 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M735 517L736 518L735 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M813 517L814 518L813 517M856 517L857 518L856 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M888 517L889 518L888 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M889 517L890 518L889 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M937 517L938 518L937 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M964 517L965 518L964 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M966 517L966 520L967 520L966 517M324 518L325 519L324 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M351 518L352 519L351 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M352 518L353 519L352 518M391 518L392 519L391 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M426 518L427 519L426 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M434 518L435 519L434 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M504 518L505 519L504 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M547 518L548 519L547 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M574 518L575 519L574 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M575 518L576 519L575 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M736 518L737 519L736 518M744 518L745 519L744 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M814 518L815 519L814 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M815 518L816 519L815 518M858 518L859 519L858 518M886 518L887 519L886 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M887 518L888 519L887 518M938 518L939 519L938 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M939 518L940 519L939 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M963 518L964 519L963 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M325 519L326 520L325 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M326 519L327 520L326 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M349 519L350 520L349 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M350 519L351 520L350 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M392 519L393 520L392 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M399 519L400 520L399 519M426 519L427 520L426 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M433 519L434 520L433 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M505 519L506 520L505 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M506 519L507 520L506 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M549 519L550 520L549 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M550 519L551 520L550 519M572 519L573 520L572 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M573 519L574 520L573 519M736 519L737 520L736 519M744 519L745 520L744 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M816 519L817 520L816 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M859 519L860 520L859 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M860 519L861 520L860 519M884 519L885 520L884 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M885 519L886 520L885 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M940 519L941 520L940 519M961 519L962 520L961 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M240 520L241 521L240 520M254 520L255 521L254 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M285 520L285 521L299 521L285 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M328 520L329 521L328 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M329 520L330 521L329 520M346 520L347 521L346 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M347 520L348 521L347 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M348 520L349 521L348 520M392 520L393 521L392 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M427 520L427 521L433 522L433 521L427 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M433 520L434 521L433 520M507 520L508 521L507 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M508.667 520.333L509.333 520.667L508.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M527 520L528 521L527 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M551 520L552 521L551 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M552.667 520.333L553.333 520.667L552.667 520.333M569 520L570 521L569 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M570 520L571 521L570 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M571 520L572 521L571 520M630 520L631 521L630 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M659 520L659 521L673 521L659 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M673 520L674 521L673 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M692 520L693 521L692 520M706 520L707 521L706 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M737 520L737 521L743 522L743 521L737 520M743 520L744 521L743 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M776 520L777 521L776 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M777 520L777 521L791 521L777 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M818 520L819 521L818 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M819 520L820 521L819 520M837 520L838 521L837 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M862 520L863 521L862 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M863 520L864 521L863 520M881 520L882 521L881 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M882 520L883 521L882 520M942 520L943 521L942 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M943 520L944 521L943 520M958 520L959 521L958 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M959 520L960 521L959 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M966 520L967 521L966 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M979 520L980 521L979 520M1007 520L1008 521L1007 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1027 520L1027 521L1041 521L1027 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M331 521L332 522L331 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M332 521L333 522L332 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M333 521L333 522L343 522L333 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M343 521L344 522L343 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M344.667 521.333L345.333 521.667L344.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M393 521L393 522L398 522L393 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M398 521L399 522L398 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M427 521L428 522L427 521M510 521L511 522L510 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M511.667 521.333L512.333 521.667L511.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 521L513 522L523 522L513 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M523 521L524 522L523 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M524 521L525 522L524 521M554 521L555 522L554 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M555 521L556 522L555 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M556 521L556 522L566 522L556 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M566.667 521.333L567.333 521.667L566.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M737 521L738 522L737 521M821 521L822 522L821 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M822 521L823 522L822 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M823 521L823 522L834 522L823 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M834 521L835 522L834 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M835 521L836 522L835 521M865 521L866 522L865 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M866 521L867 522L866 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M867 521L867 522L878 522L867 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M878 521L879 522L878 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M879 521L880 522L879 521M944 521L945 522L944 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M945 521L946 522L945 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M946 521L946 522L955 522L946 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M955 521L956 522L955 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M956 521L957 522L956 521M394 524L395 525L394 524M1067 565L1068 566L1067 565M1133 565L1134 566L1133 565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M313 566L314 567L313 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M314 566L315 567L314 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M315.005 566.613C304.222 569.204 308.491 585.131 318.996 582.551C329.803 579.897 325.486 564.094 315.005 566.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M319 566L320 567L319 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M320 566L321 567L320 566M478 566L479 567L478 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M479 566L480 567L479 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M480.005 566.693C469.392 569.531 473.624 585.098 483.996 582.551C494.802 579.897 490.448 563.9 480.005 566.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M484 566L485 567L484 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M485 566L486 567L485 566M1036 566L1037 567L1036 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1037 566L1037 567L1040 567L1037 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1040 566L1040 567L1049 567L1040 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1049 566L1050 567L1049 566M1063 566L1064 567L1063 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1064.67 566.333L1065.33 566.667L1064.67 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1066 566.616C1055.09 569.152 1058.98 585.475 1070 582.562C1079.96 579.927 1076.15 564.257 1066 566.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1070 566L1071 567L1070 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1071 566L1072 567L1071 566M1129 566L1130 567L1129 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1130 566L1131 567L1130 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1131.02 566.668C1120.57 569.711 1125.45 585.385 1135.98 582.562C1146.47 579.753 1141.16 563.714 1131.02 566.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1136 566L1137 567L1136 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1137 566L1138 567L1137 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M311 567L312 568L311 567M322 567L323 568L322 567M476 567L477 568L476 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M477 567L478 568L477 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M487 567L488 568L487 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1035 567L1035 618C1035 625.19 1033.27 634.948 1035.32 641.852C1036.52 645.903 1044.48 645.973 1047.68 644.397C1052.17 642.188 1050 629.226 1050 625L1050 567L1049 567L1049 644L1036 644L1036 591L1035 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1036 567L1036 644L1049 644L1049 567L1036 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1062 567L1063 568L1062 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1072 567L1073 568L1072 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1073 567L1074 568L1073 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1128 567L1129 568L1128 567M1138 567L1139 568L1138 567M310 568L311 569L310 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M323 568L324 569L323 568M475 568L476 569L475 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M488 568L489 569L488 568M1061 568L1062 569L1061 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1074 568L1075 569L1074 568M1126 568L1127 569L1126 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1139 568L1140 569L1139 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M309 569L310 570L309 569M324 569L325 570L324 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M474 569L475 570L474 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M489 569L490 570L489 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1060 569L1061 570L1060 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1075 569L1076 570L1075 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1140 569L1141 570L1140 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M490 570L491 571L490 570M1059 570L1060 571L1059 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1075 570L1076 571L1075 570M1125 570L1126 571L1125 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1141 570L1142 571L1141 570M308 571L309 572L308 571M325 571L326 572L325 571M473 571L474 572L473 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M490.333 571.667L490.667 572.333L490.333 571.667M1059 571L1060 572L1059 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1076 571L1077 572L1076 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M308 572L309 573L308 572M325 572L326 573L325 572M473 572L474 573L473 572M1076 572L1076 577L1077 577L1076 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1124 572L1125 573L1124 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1142 572L1143 573L1142 572M491 573L491 576L492 576L491 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1124 573L1124 577L1125 577L1124 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1142 573L1142 577L1143 577L1142 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M53 574L53 575L56 575L53 574M1058 574L1058 577L1059 577L1058 574M45 575L46 576L45 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M46 575L47 576L46 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M47 575L47 576L50 576L47 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M50 575.428C21.7413 579.484 7.47099 614.888 29.1736 635.7C38.3551 644.504 50.7317 646.511 63 644.699C107.481 638.129 93.6536 569.163 50 575.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M60.6667 575.333L61.3333 575.667L60.6667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M62 575L63 576L62 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M63 575L64 576L63 575M875 575L876 576L875 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M876 575L877 576L876 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M877.667 575.333L878.333 575.667L877.667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M914 628L903 622C890.837 639.122 862.579 633.977 862.055 611C861.515 587.344 890.509 581.319 903 599L914 592C894.675 558.568 841.717 579.579 848.465 617C853.623 645.611 902.01 658.949 914 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M888 575L888 576L891 576L888 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M891 575L892 576L891 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M892 575L893 576L892 575M42 576L43 577L42 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M43 576L44 577L43 576M65 576L66 577L65 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M66 576L67 577L66 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M67 576L68 577L67 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M473.333 576.667L473.667 577.333L473.333 576.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M871 576L872 577L871 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M872 576L873 577L872 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M873 576L874 577L873 576M894 576L895 577L894 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M895 576L896 577L895 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M39 577L40 578L39 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M40 577L41 578L40 577M68 577L69 578L68 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M69 577L70 578L69 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M308 577L309 578L308 577M325 577L326 578L325 577M490 577L491 578L490 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M869 577L870 578L869 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M870 577L871 578L870 577M897 577L898 578L897 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M898 577L899 578L898 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1059 577L1060 578L1059 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1076 577L1077 578L1076 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1124 577L1125 578L1124 577M37 578L38 579L37 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M38 578L39 579L38 578M70 578L71 579L70 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M71 578L72 579L71 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M308 578L309 579L308 578M325 578L326 579L325 578M473 578L474 579L473 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M490 578L491 579L490 578M867 578L868 579L867 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M899 578L900 579L899 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M900 578L901 579L900 578M1059 578L1060 579L1059 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1125 578L1126 579L1125 578M1141 578L1142 579L1141 578M36 579L37 580L36 579M72 579L73 580L72 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M73 579L74 580L73 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M309 579L310 580L309 579M324 579L325 580L324 579M474 579L475 580L474 579M489 579L490 580L489 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M865 579L866 580L865 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M901 579L902 580L901 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M902 579L903 580L902 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1075 579L1076 580L1075 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1125 579L1126 580L1125 579M1141 579L1142 580L1141 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M34 580L35 581L34 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M74 580L75 581L74 580M310 580L311 581L310 580M323 580L324 581L323 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M437 580L438 581L437 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M437 593C428.441 593.101 429 597.62 429 605L430 605L430 594C439.006 593.893 438 588.57 438 581L451 581C451 593.721 453.864 594 466 594L466 593L452 593C452 589.844 452.824 585.218 451.397 582.318C449.754 578.979 440.234 578.817 438.028 581.603C435.953 584.223 437 589.855 437 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M451 580L452 581L451 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M475 580L476 581L475 580M488 580L489 581L488 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M647 580L648 581L647 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M647 592L648 592L648 581L661 581C661 593.721 663.864 594 676 594L676 593L662 593C662 589.855 663.047 584.223 660.972 581.603C658.933 579.029 650.067 579.029 648.028 581.603C646.089 584.051 647 589.073 647 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M661 580L662 581L661 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M864 580L865 581L864 580M903 580L904 581L903 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1060 580L1061 581L1060 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1074 580L1075 581L1074 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1088 580L1088 593L1089 593L1088 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1089 580L1089 581L1103 581L1089 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1126 580L1127 581L1126 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1140 580L1141 581L1140 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M33 581L34 582L33 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M76 581L77 582L76 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M311 581L312 582L311 581M322 581L323 582L322 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M438 581C438 588.143 438.584 593.72 430 594L430 605L438 605C438 617.14 433.687 638.239 448 643.852C453.705 646.089 460.981 645 467 645L467 633C448.291 633 451 620.01 451 605L466 605L466 594C454.383 594 451 593.267 451 581L438 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M476 581L477 582L476 581M487 581L488 582L487 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M527 581L528 582L527 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M648 581C648 588.143 648.584 593.72 640 594L640 605L648 605C648 617.14 643.687 638.239 658 643.852C663.705 646.089 670.981 645 677 645L677 633C658.291 633 661 620.01 661 605L676 605L676 594C664.383 594 661 593.267 661 581L648 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M862 581L863 582L862 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M905 581L906 582L905 581M1061 581L1062 582L1061 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1073 581L1074 582L1073 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1089 581L1089 594L1081 594L1081 605L1089 605C1089 615.114 1086.12 630.362 1092.65 638.906C1096.35 643.746 1113.14 649.494 1117.97 643.397C1119.91 640.949 1119 635.927 1119 633C1099.62 633 1103 620.665 1103 605L1117 605L1117 594L1103 594L1103 581L1089 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1127 581L1128 582L1127 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1139 581L1140 582L1139 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M32 582L33 583L32 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M77 582L78 583L77 582M312 582L313 583L312 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M313 582L314 583L313 582M320 582L321 583L320 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M321 582L322 583L321 582M477 582L478 583L477 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M478 582L479 583L478 582M485 582L486 583L485 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M486 582L487 583L486 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M861 582L862 583L861 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M906 582L907 583L906 582M1063 582L1064 583L1063 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1071 582L1072 583L1071 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1072 582L1073 583L1072 582M1128 582L1129 583L1128 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1129 582L1130 583L1129 582M1137 582L1138 583L1137 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M30 583L31 584L30 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M78 583L79 584L78 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M314 583L315 584L314 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M315 583L315 584L318 584L315 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M318.667 583.333L319.333 583.667L318.667 583.333M479 583L480 584L479 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M480 583L480 584L484 584L480 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M484 583L485 584L484 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M860 583L861 584L860 583M907 583L908 584L907 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1065 583L1066 584L1065 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1066 583L1066 584L1069 584L1066 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1069 583L1070 584L1069 583M1131 583L1132 584L1131 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1132 583L1132 584L1135 584L1132 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1135 583L1136 584L1135 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M29 584L30 585L29 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M79 584L80 585L79 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M524 584L525 585L524 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M908 584L909 585L908 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M28 585L29 586L28 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M80 585L81 586L80 585M858 585L859 586L858 585M909 585L910 586L909 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M27 586L28 587L27 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M81 586L82 587L81 586M910 586L911 587L910 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M26 587L27 588L26 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M82 587L83 588L82 587M856 587L857 588L856 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M911 587L912 588L911 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M25 588L26 589L25 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M48.6667 588.333L49.3333 588.667L48.6667 588.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M50.6667 588.333L51.3333 588.667L50.6667 588.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M52.6667 588.333L53.3333 588.667L52.6667 588.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M54 588.598C25.2166 589.943 28.1412 633.329 57 631.96C83.9107 630.683 81.0523 587.333 54 588.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M56.6667 588.333L57.3333 588.667L56.6667 588.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M58 588L59 589L58 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M59.6667 588.333L60.3333 588.667L59.6667 588.333M83 588L84 589L83 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M520 588L521 589L520 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M855 588L856 589L855 588M878.667 588.333L879.333 588.667L878.667 588.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M880 588L881 589L880 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M881.667 588.333L882.333 588.667L881.667 588.333M886.667 588.333L887.333 588.667L886.667 588.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M888 588L889 589L888 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M889 588L890 589L889 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M912 588L913 589L912 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M25 589L26 590L25 589M46 589L47 590L46 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M47 589L48 590L47 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M62 589L63 590L62 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M63 589L64 590L63 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M84 589L85 590L84 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M854 589L855 590L854 589M875 589L876 590L875 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M876 589L877 590L876 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M891 589L892 590L891 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M892 589L893 590L892 589M912 589L913 590L912 589M24 590L25 591L24 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M44 590L45 591L44 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M64 590L65 591L64 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M65 590L66 591L65 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M85 590L86 591L85 590M853 590L854 591L853 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M873 590L874 591L873 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M874 590L875 591L874 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M894 590L895 591L894 590M913 590L914 591L913 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M23 591L24 592L23 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M42 591L43 592L42 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M66 591L67 592L66 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M85 591L86 592L85 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M872 591L873 592L872 591M895 591L896 592L895 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M896 591L897 592L896 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M914 591L915 592L914 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M41 592L42 593L41 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M68 592L69 593L68 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M86 592L87 593L86 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M123 592L124 593L123 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M124 592L124 593L128 593L124 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M128.667 592.333L129.333 592.667L128.667 592.333M150.667 592.333L151.333 592.667L150.667 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M152 592L152 593L156 593L152 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M173 637C172.908 647.128 165.487 654.174 155 651.211C151.484 650.218 146.878 646.152 143.174 646.878C140.079 647.484 137.809 651.729 136 654L136 655C149.743 666.676 178.047 669.712 185.451 649C191.049 633.343 187 610.532 187 594L175 594L175 599C170.421 596.022 166.514 593.49 161 592.63C124.296 586.91 125.257 649.268 162 642.381C166.397 641.557 169.574 639.806 173 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M160 592L160 593L163 593L160 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M163 592L164 593L163 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M164 592L165 593L164 592M212 592L213 593L212 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M213 592L214 593L213 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M214 592L214 593L217 593L214 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M204 611L205 611C208.831 607.514 213.388 603.514 219 604.384C222.711 604.96 228.701 609.186 226.667 613.682C225.23 616.859 219.768 615.998 217 616C210.619 616.005 203.302 615.991 198.803 621.329C192.611 628.677 195.951 641.069 205.001 644.146C213.535 647.047 221.619 644.048 229 640L229 644L241 644C241 630.388 246.08 604.785 232.96 595.97C221.667 588.382 188.821 594.305 204 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M221 592L221 593L225 593L221 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M225 592L226 593L225 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M226 592L227 593L226 592M273 592L274 593L273 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M274 592L275 593L274 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M275.667 592.333L276.333 592.667L275.667 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M265 597C263.96 592.147 256.102 594 252 594L252 644L266 644C266 634.266 261.266 608.734 273.715 605.183C279.015 603.671 283.737 608.372 285.196 613.001C288.075 622.134 286 634.476 286 644L299 644C299 627.114 304.904 586.841 276 592.673C272.042 593.471 268.564 595.179 265 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M282 592L282 593L285 593L282 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M285 592L286 593L285 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M395 592L396 593L395 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M396 592L397 593L396 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M397 592L397 593L400 593L397 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M386 611C395.221 605.753 409.495 598.992 410 616C401.776 616 391.276 614.238 384.043 618.995C375.48 624.626 376.55 637.791 385.015 642.991C392.84 647.797 404.13 644.886 411 640L411 644L424 644C424 630.107 428.581 606.147 415.985 596.558C409.431 591.569 381.257 589.911 381.345 603.015C381.364 605.857 384.491 608.779 386 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M401 592L401 593L407 593L401 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M407 592L408 593L407 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M408 592L409 593L408 592M517 592L518 593L517 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M518 592L519 593L518 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M519 592L519 593L522 593L519 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M522 592.443C500.131 595.075 488.67 623.025 506.093 638.671C512.748 644.647 521.393 645.792 530 644.826C563.67 641.046 555.453 588.416 522 592.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M527 592L527 593L531 593L527 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M531 592L532 593L531 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M532 592L533 593L532 592M582 592L583 593L582 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M583 592L584 593L583 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M584 592L584 593L588 593L584 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M573 598L573 594L561 594L561 644L574 644C574 635.009 569.192 603.219 585 604.902C598.89 606.381 594 634.611 594 644L607 644C607 625.161 613.404 587.344 583 593.174C579.181 593.907 576.12 595.781 573 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M590 592L590 593L593 593L590 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M593 592L594 593L593 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M594 592L595 593L594 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M647 592L648 593L647 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M701 592L702 593L701 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M702 592L703 593L702 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M703 592L703 593L706 593L703 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M706 592.562C685.789 594.212 673.894 618.377 686.557 634.985C693.041 643.49 702.848 645.74 713 644.907C747.406 642.084 739.854 589.8 706 592.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M708 592L708 593L711 593L708 592M712.667 592.333L713.333 592.667L712.667 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M714 592L715 593L714 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M715 592L716 593L715 592M784 592L785 593L784 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M785 592L786 593L785 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786 592L786 593L790 593L786 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M776 611L777 611C785.534 603.745 799.16 600.657 800 616C791.413 616 780.369 614.126 773.055 619.649C764.773 625.902 767.19 639.109 776.001 643.543C784.156 647.647 793.86 644.254 801 640L801 644L813 644C813 630.747 817.971 605.703 805.957 596.638C794.764 588.193 762.133 593.705 776 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M791.667 592.333L792.333 592.667L791.667 592.333M794 592L794 593L797 593L794 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M797 592L798 593L797 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M798 592L799 593L798 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M852 592L853 593L852 592M870 592L871 593L870 592M897 592L898 593L897 592M913 592L914 593L913 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M939 592L940 593L939 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M940 592L941 593L940 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M941.667 592.333L942.333 592.667L941.667 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M943 592.443C905.749 597.866 916.291 651.122 953 644.671C985.444 638.97 975.245 587.749 943 592.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M949 592L949 593L952 593L949 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M952 592L953 593L952 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M996 592L997 593L996 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M997 592L998 593L997 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M998.667 592.333L999.333 592.667L998.667 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M987 611C996.317 605.255 1010.13 599.252 1011 616C1002.5 616 991.295 614.071 984.105 619.649C975.962 625.967 978.152 639.056 987.004 643.543C994.933 647.562 1005.13 644.487 1012 640L1012 644L1025 644C1022.86 630.744 1029.16 608.332 1018.81 598.213C1011.39 590.96 998.883 591.1 990 595.328C987.127 596.695 982.232 599.27 982.206 603.004C982.186 605.847 985.477 608.798 987 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1001.67 592.333L1002.33 592.667L1001.67 592.333M1005 592L1005 593L1008 593L1005 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1008 592L1009 593L1008 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1009 592L1010 593L1009 592M1169 592L1170 593L1169 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1170 592L1171 593L1170 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1171.67 592.333L1172.33 592.667L1171.67 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1173 592.443C1135.71 597.871 1146.34 651.114 1183 644.671C1215.41 638.975 1205.32 587.738 1173 592.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1179 592L1179 593L1182 593L1179 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1182 592L1183 593L1182 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1183 592L1184 593L1183 592M1233 592L1234 593L1233 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1234 592L1235 593L1234 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1235 592L1235 593L1238 593L1235 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1224 597L1225 594L1212 594L1212 644L1226 644C1226 635.121 1222.3 615.188 1228.43 608.225C1233.04 603 1241.7 604.533 1244.26 611.015C1247.76 619.9 1245 634.488 1245 644L1259 644C1259 627.51 1264.98 590.467 1238.58 592.464C1233.19 592.872 1228.95 595.202 1224 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1239 592L1240 593L1239 592M1242.67 592.333L1243.33 592.667L1242.67 592.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1244 592L1245 593L1244 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1245 592L1246 593L1245 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M22 593L23 594L22 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M40 593L41 594L40 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M69 593L70 594L69 593M99 593L99 594L112 594L99 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M119 593L120 594L119 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M120.667 593.333L121.333 593.667L120.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M112 599L112 594L99 594C102.349 608.068 101.634 628.81 99 643L113 644C113 627.527 108.618 605.976 131 605C130.893 602.164 131.821 596.925 129.969 594.6C125.775 589.332 115.468 596.158 112 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M130 593L131 594L130 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M148 593L149 594L148 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M149 593L150 594L149 593M165 593L166 594L165 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M166 593L167 594L166 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M174 593L174 599L175 599L175 594L187 594L174 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M187 593L187 643L188 643C188 628.951 192.409 605.89 187 593M209 593L210 594L209 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M210 593L211 594L210 593M228 593L229 594L228 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M229 593L230 594L229 593M251 593L251 640L252 640C252 626.735 256.109 605.177 251 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M252 593L252 594L265 594L252 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M265 593L265 597L266 597L265 593M270 593L271 594L270 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M271 593L272 594L271 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M272 593L273 594L272 593M287 593L288 594L287 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M288 593L289 594L288 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M310 593L310 594L324 594L310 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M332 593L333 594L332 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M332 605L333 605L333 594L375 594L344 593L333.603 594.028L332 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M392 593L393 594L392 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M393 593L394 594L393 593M410 593L411 594L410 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M411 593L412 594L411 593M429 593L430 594L429 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M466 593L466 605L467 605L466 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M475 593L475 594L489 594L475 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M489 593L489 642L490 642C490 628.212 494.309 605.652 489 593M514 593L515 594L514 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M515 593L516 594L515 593M533 593L534 594L533 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M534 593L535 594L534 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M535 593L536 594L535 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M560 593L561 594L560 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M561 593L561 594L574 595L561 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M573 593L574 594L573 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M579 593L580 594L579 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M580 593L581 594L580 593M595 593L596 594L595 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M596 593L597 594L596 593M639 593L640 594L639 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M640 593L640 594L647 594L640 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M676 593L676 600L677 600L676 593M698 593L699 594L698 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M699 593L700 594L699 593M717 593L718 594L717 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M718 593L719 594L718 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M781 593L782 594L781 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M782.667 593.333L783.333 593.667L782.667 593.333M800 593L801 594L800 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M801 593L802 594L801 593M851 593L852 594L851 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M869 593L870 594L869 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M898 593L899 594L898 593M912 593L913 594L912 593M936 593L937 594L936 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M937 593L938 594L937 593M954.667 593.333L955.333 593.667L954.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M956 593L957 594L956 593M992 593L993 594L992 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M993 593L994 594L993 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M994 593L995 594L994 593M1011 593L1012 594L1011 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1012 593L1013 594L1012 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1060 593L1060 645L1061 645L1061 610L1060 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1061 593L1061 594L1075 594L1061 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1080 593L1080 605L1081 605L1080 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1081 593L1081 594L1089 594L1081 593M1103 593L1103 594L1117 594L1103 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1117 593L1118 594L1117 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1126 593L1127 594L1126 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1127.6 594.028C1124.65 596.368 1126 603.684 1126 607C1126 617.399 1123.36 631.892 1126.32 641.852C1127.52 645.897 1136.47 646.292 1139.4 643.972C1142.35 641.633 1141 634.315 1141 631C1141 620.601 1143.64 606.108 1140.68 596.148C1139.48 592.103 1130.53 591.708 1127.6 594.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1140 593L1141 594L1140 593M1166 593L1167 594L1166 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1167 593L1168 594L1167 593M1184.67 593.333L1185.33 593.667L1184.67 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1186 593L1187 594L1186 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1212 593L1212 594L1225 594L1212 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1230 593L1231 594L1230 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1231 593L1232 594L1231 593M1247 593L1248 594L1247 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1248 593L1249 594L1248 593M39 594L40 595L39 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M70 594L71 595L70 594M87 594L88 595L87 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M112 594L113 598L114 598L112 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M117 594L118 595L117 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M118 594L119 595L118 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M145 594L146 595L145 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M146 594L147 595L146 594M168 594L169 595L168 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M207 594L208 595L207 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M230 594L231 595L230 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M231 594L232 595L231 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M269 594L270 595L269 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M290 594L291 595L290 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M309 594L309 598L310 598L309 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M310 594L310 644L324 644L324 594L310 594M333 594L333 605L354 605C347.36 616.926 331.815 630.408 330 644L375 644L375 633L351 633C357.796 620.793 372.344 607.726 375 594L333 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M389 594L390 595L389 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M390 594L391 595L390 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M413 594L414 595L413 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M474 594L475 595L474 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M475 594L475 644L489 644L489 594L475 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M507 594L508 595L507 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M512 594L513 595L512 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 594L514 595L513 594M536 594L537 595L536 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M537 594L538 595L537 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M560 594L560 628C560 632.155 558.732 638.878 560.603 642.682C562.356 646.245 572.644 646.245 574.397 642.682C577.881 635.6 575 620.881 575 613L574 613L574 644L561 644C561 629.951 565.409 606.889 560 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M577 594L578 595L577 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M578 594L579 595L578 594M598 594L599 595L598 594M639 594L640 595L639 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M696 594L697 595L696 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M697 594L698 595L697 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M720 594L721 595L720 594M779 594L780 595L779 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M780 594L781 595L780 594M802 594L803 595L802 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M803 594L803 595L806 596L803 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M851 594L852 595L851 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M868 594L869 595L868 594M899 594L900 595L899 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M910 594L911 595L910 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M911 594L912 595L911 594M933 594L934 595L933 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M934 594L935 595L934 594M957 594L958 595L957 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M958 594L959 595L958 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M990 594L991 595L990 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M991 594L992 595L991 594M1013 594L1014 595L1013 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1014 594L1015 595L1014 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1061 594L1061 644L1075 644L1075 594L1061 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1117 594L1117 605L1118 605L1117 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9fcfb",
      stroke: "none"
    },
    d: "M1127 594L1127 644L1140 644L1140 594L1127 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1163 594L1164 595L1163 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1164 594L1165 595L1164 594M1187 594L1188 595L1187 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1188 594L1189 595L1188 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1211 594L1211 644L1212 644C1212 629.951 1216.41 606.889 1211 594M1228 594L1229 595L1228 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1229 594L1230 595L1229 594M1249 594L1250 595L1249 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1250 594L1251 595L1250 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M21 595L22 596L21 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M38 595L39 596L38 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M71 595L72 596L71 595M99 595L99 641L100 641C100 627.997 104.01 606.939 99 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M115 595L116 596L115 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M116 595L117 596L116 595M144 595L145 596L144 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M170 595L171 596L170 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M205 595L206 596L205 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M232 595L233 596L232 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M267 595L268 596L267 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M291 595L292 596L291 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M387 595L388 596L387 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M388 595L389 596L388 595M414 595L415 596L414 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M415 595L416 596L415 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M508.333 595.667L508.667 596.333L508.333 595.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M510 595L511 596L510 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M511 595L512 596L511 595M538 595L539 596L538 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M573.333 595.667L573.667 596.333L573.333 595.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M576 595L577 596L576 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M600 595L601 596L600 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M639 595L639 600L640 600L639 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M694 595L695 596L694 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 595L696 596L695 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M722 595L723 596L722 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M777 595L778 596L777 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M804 595L805 596L804 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M850 595L851 596L850 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M867 595L868 596L867 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M900 595L901 596L900 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M909 595L910 596L909 595M932 595L933 596L932 595M959 595L960 596L959 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M960 595L961 596L960 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M988 595L989 596L988 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M989 595L990 596L989 595M1015 595L1016 596L1015 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1016 595L1017 596L1016 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1162 595L1163 596L1162 595M1189 595L1190 596L1189 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1190 595L1191 596L1190 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1224.33 595.667L1224.67 596.333L1224.33 595.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1227 595L1228 596L1227 595M1251 595L1252 596L1251 595M37 596L38 597L37 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M72 596L73 597L72 596M88 596L89 597L88 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M114 596L115 597L114 596M142 596L143 597L142 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M143 596L144 597L143 596M171 596L172 597L171 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M203 596L204 597L203 596M234 596L235 597L234 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M266 596L267 597L266 596M292 596L293 597L292 596M386 596L387 597L386 596M416 596L417 597L416 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M505 596L506 597L505 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M509 596L510 597L509 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M540 596L541 597L540 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M574 596L575 597L574 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M601 596L602 597L601 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M693 596L694 597L693 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M724 596L725 597L724 596M775 596L776 597L775 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M776 596L777 597L776 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M806 596L807 597L806 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M850 596L851 597L850 596M866 596L867 597L866 596M901 596L902 597L901 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M908 596L909 597L908 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M930 596L931 597L930 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M961 596L962 597L961 596M987 596L988 597L987 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1017 596L1018 597L1017 596M1160 596L1161 597L1160 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1191 596L1192 597L1191 596M1226 596L1227 597L1226 596M1252 596L1253 597L1252 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M20 597L21 598L20 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M36 597L37 598L36 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M72 597L73 598L72 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M112 597L113 598L112 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M141 597L142 598L141 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M172 597L173 598L172 597M202 597L203 598L202 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M235 597L236 598L235 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M374 597L375 598L374 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M384 597L385 598L384 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M385 597L386 598L385 597M417 597L418 598L417 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M507 597L508 598L507 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M541 597L542 598L541 597M573 597L574 598L573 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M602 597L603 598L602 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M691 597L692 598L691 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M725 597L726 598L725 597M774 597L775 598L774 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M807 597L808 598L807 597M902 597L903 598L902 597M906 597L907 598L906 597M929 597L930 598L929 597M962 597L963 598L962 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M963 597L964 598L963 597M985 597L986 598L985 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1018 597L1019 598L1018 597M1159 597L1160 598L1159 597M1192 597L1193 598L1192 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1193 597L1194 598L1193 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1253 597L1254 598L1253 597M20 598L21 599L20 598M73 598L74 599L73 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M89 598L90 599L89 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M112 598L113 599L112 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M140 598L141 599L140 598M173 598L174 599L173 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M201 598L202 599L201 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M236 598L237 599L236 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M294 598L295 599L294 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M383 598L384 599L383 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M418 598L419 599L418 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M506 598L507 599L506 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M542 598L543 599L542 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M603 598L604 599L603 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M690 598L691 599L690 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M726 598L727 599L726 598M773 598L774 599L773 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M808 598L809 599L808 598M849 598L850 599L849 598M865 598L866 599L865 598M905 598L906 599L905 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M928 598L929 599L928 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M964 598L965 599L964 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M984 598L985 599L984 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1019 598L1020 599L1019 598M1158 598L1159 599L1158 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1194 598L1195 599L1194 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1254 598L1255 599L1254 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M35 599L36 600L35 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M89 599L90 600L89 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M139 599L140 600L139 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M237 599L238 600L237 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M295 599L296 600L295 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M309 599L309 624L310 624L309 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M373 599L374 600L373 599M382 599L383 600L382 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M419 599L420 600L419 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M494 599L495 600L494 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M505 599L506 600L505 599M689 599L690 600L689 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M727 599L728 600L727 599M772 599L773 600L772 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M809 599L810 600L809 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M849 599L850 600L849 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M903.667 599.333L904.333 599.667L903.667 599.333M926 599L927 600L926 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M965 599L966 600L965 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M983 599L984 600L983 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1020 599L1021 600L1020 599M1195 599L1196 600L1195 599M1255 599L1256 600L1255 599M19 600L20 601L19 600M74 600L75 601L74 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M130 600L131 601L130 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M138 600L139 601L138 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M198 600L199 601L198 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M237 600L238 601L237 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M296 600L297 601L296 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M372 600L373 601L372 600M381 600L382 601L381 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M420 600L421 601L420 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M498 600L499 601L498 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M504 600L505 601L504 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M545 600L546 601L545 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M604 600L605 601L604 600M639 600L640 601L639 600M688 600L689 601L688 600M771 600L772 601L771 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M810 600L811 601L810 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M864 600L865 601L864 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M925 600L926 601L925 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M966 600L967 601L966 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M982 600L983 601L982 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1021 600L1022 601L1021 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1196 600L1197 601L1196 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M19 601L20 602L19 601M34 601L35 602L34 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M74 601L75 602L74 601M90 601L91 602L90 601M137 601L138 602L137 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M238 601L239 602L238 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M296 601L297 602L296 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M380 601L381 602L380 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M495 601L491 618L492 618C492.653 616.04 493 615.446 493 618L494 618L494 608L499 605L496 606L497 601L495 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M503 601L504 602L503 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M605 601L606 602L605 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M639.333 601.667L639.667 602.333L639.333 601.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M676 601L676 605L677 605L676 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M687 601L688 602L687 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M729 601L730 602L729 601M770 601L771 602L770 601M810 601L811 602L810 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M848 601L849 602L848 601M967 601L968 602L967 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M981 601L982 602L981 601M1021 601L1022 602L1021 601M1155 601L1156 602L1155 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1197 601L1198 602L1197 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1256 601L1257 602L1256 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M34 602L35 603L34 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M75 602L76 603L75 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M90 602L91 603L90 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M137 602L138 603L137 602M197.333 602.667L197.667 603.333L197.333 602.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M239 602L240 603L239 602M297 602L298 603L297 602M371 602L372 603L371 602M379 602L380 603L379 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M421 602L422 603L421 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M498 602L499 603L498 602M502 602L503 603L502 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M546 602L547 603L546 602M605 602L606 603L605 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M686 602L687 603L686 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M730 602L731 603L730 602M769 602L770 603L769 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M811 602L812 603L811 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M848.333 602.667L848.667 603.333L848.333 602.667M863 602L864 603L863 602M924 602L925 603L924 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M968 602L969 603L968 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M980 602L981 603L980 602M1022 602L1023 603L1022 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1154 602L1155 603L1154 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1198 602L1199 603L1198 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M75 603L76 604L75 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M90.3333 603.667L90.6667 604.333L90.3333 603.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M136 603L137 604L136 603M239 603L240 604L239 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M297 603L298 604L297 603M370 603L371 604L370 603M380 603L381 604L380 603M547 603L548 604L547 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M606 603L607 604L606 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M639 603L640 604L639 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M731 603L732 604L731 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M769 603L770 604L769 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M811 603L812 604L811 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M863 603L864 604L863 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M923 603L924 604L923 603M968 603L969 604L968 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M980 603L981 604L980 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1153 603L1154 604L1153 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1257 603L1258 604L1257 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M18 604L19 605L18 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M33 604L34 605L33 604M156 604L157 605L156 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M157.667 604.333L158.333 604.667L157.667 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M159 604L159 605L162 605L159 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M162.667 604.333L163.333 604.667L162.667 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M164 604L165 605L164 604M198 604L199 605L198 604M214 604L214 605L217 605L214 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M217.667 604.333L218.333 604.667L217.667 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M219.667 604.333L220.333 604.667L219.667 604.333M274 604L275 605L274 604M369 604L370 605L369 604M397.667 604.333L398.333 604.667L397.667 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M399 604L399 605L402 605L399 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M402.667 604.333L403.333 604.667L402.667 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M422 604L423 605L422 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M501 604L502 605L501 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M548 604L549 605L548 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M583 604L583 605L586 605L583 604M606.333 604.667L606.667 605.333L606.333 604.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M639 604L640 605L639 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M685 604L686 605L685 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M732 604L733 605L732 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M770 604L771 605L770 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786 604L786 605L789 605L786 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789 604L789 605L792 605L789 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M792.667 604.333L793.333 604.667L792.667 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M812 604L813 605L812 604M863 604L864 605L863 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M922 604L923 605L922 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M969 604L970 605L969 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M981 604L982 605L981 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M997 604L997 605L1000 605L997 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1000 604L1000 605L1003 605L1000 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1003.67 604.333L1004.33 604.667L1003.67 604.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1023 604L1024 605L1023 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1152 604L1153 605L1152 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1199 604L1200 605L1199 604M1234.67 604.333L1235.33 604.667L1234.67 604.333M1257 604L1258 605L1257 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M18.3333 605.667L18.6667 606.333L18.3333 605.667M33 605L34 606L33 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M125 605L125 606L131 606L125 605M135 605L136 606L135 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M154 605L155 606L154 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M155.005 605.742C140.138 611.521 150.657 636.396 165.985 629.346C180.547 622.649 170.484 599.726 155.005 605.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M166 605L167 606L166 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M199 605L200 606L199 605M211 605L212 606L211 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M212 605L213 606L212 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M213 605L214 606L213 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M222 605L223 606L222 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M223 605L224 606L223 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M240 605L241 606L240 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M271 605L272 606L271 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M272 605L273 606L272 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M273 605L274 606L273 605M278 605L279 606L278 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M279 605L280 606L279 605M298 605L299 606L298 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M333 605L333 606L354 606L333 605M369 605L370 606L369 605M381 605L382 606L381 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M394 605L395 606L394 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M395 605L396 606L395 605M404 605L405 606L404 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M405 605L406 606L405 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M422 605L423 606L422 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M429 605L429 606L437 606L429 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M437 605L437 629L438 629L437 605M451 605L451 628L452 628L451 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M452 605L452 606L466 606L452 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M500 605L501 606L500 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M520 605L521 606L520 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M521 605L522 606L521 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M522.667 605.333L523.333 605.667L522.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M524 605.641C506.965 607.005 509.588 633.745 527 631.89C542.69 630.219 539.717 604.383 524 605.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M526.667 605.333L527.333 605.667L526.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M528 605L529 606L528 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M580 605L581 606L580 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M581 605L582 606L581 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M587 605L588 606L587 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M588 605L589 606L588 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M640 605L640 606L647 606L640 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M647.333 605.667L647.667 606.333L647.333 605.667M661 605L661 628L662 628L661 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M662 605L662 606L676 606L662 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M684 605L685 606L684 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M704 605L705 606L704 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M705 605L706 606L705 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M706 605L707 606L706 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M707 605.569C690.326 607.783 694.036 634.003 711 631.866C726.567 629.905 723.074 603.435 707 605.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M710 605L711 606L710 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M711.667 605.333L712.333 605.667L711.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M732 605L733 606L732 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M771 605L772 606L771 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M784 605L785 606L784 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M785 605L786 606L785 605M794 605L795 606L794 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M795 605L796 606L795 605M812.333 605.667L812.667 606.333L812.333 605.667M862 605L862 608L863 608L862 605M922 605L923 606L922 605M941 605L942 606L941 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M942 605L943 606L942 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M943.667 605.333L944.333 605.667L943.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M945 605.639C928.34 607.175 930.804 633.722 948 631.89C963.845 630.203 961.258 604.14 945 605.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M947.667 605.333L948.333 605.667L947.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M949 605L950 606L949 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M950 605L951 606L950 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M970 605L971 606L970 605M982 605L983 606L982 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M995 605L996 606L995 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M996 605L997 606L996 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1006 605L1007 606L1006 605M1023 605L1024 606L1023 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1081 605L1081 606L1088 606L1088 630C1091.42 621.848 1091.71 605.127 1081 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1088 605L1089 606L1088 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1103 605L1103 606L1117 606L1103 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1171 605L1172 606L1171 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1172 605L1173 606L1172 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1173.67 605.333L1174.33 605.667L1173.67 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M1175 605.562C1158.62 607.393 1161 633.558 1178 631.887C1193.91 630.325 1191.07 603.765 1175 605.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1178 605L1179 606L1178 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1179 605L1180 606L1179 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1180 605L1181 606L1180 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1200 605L1201 606L1200 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1231 605L1232 606L1231 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1232 605L1233 606L1232 605M1238 605L1239 606L1238 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1239 605L1240 606L1239 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1258 605L1259 606L1258 605M33.3333 606.667L33.6667 607.333L33.3333 606.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M76.3333 606.667L76.6667 607.333L76.3333 606.667M121 606L122 607L121 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M122.667 606.333L123.333 606.667L122.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M152 606L153 607L152 606M168 606L169 607L168 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M210 606L211 607L210 606M224 606L225 607L224 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M240.333 606.667L240.667 607.333L240.333 606.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M270 606L271 607L270 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M281 606L282 607L281 606M298.333 606.667L298.667 607.333L298.333 606.667M353 606L354 607L353 606M368 606L369 607L368 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M382 606L383 607L382 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M392 606L393 607L392 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M393 606L394 607L393 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M407 606L408 607L407 606M500 606L501 607L500 606M518 606L519 607L518 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M519 606L520 607L519 606M530 606L531 607L530 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M531 606L532 607L531 606M549 606L550 607L549 606M578 606L579 607L578 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M589 606L590 607L589 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M702 606L703 607L702 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M714 606L715 607L714 606M733 606L734 607L733 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M772 606L773 607L772 606M782 606L783 607L782 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M796 606L797 607L796 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M921 606L922 607L921 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M939 606L940 607L939 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M940 606L941 607L940 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M952 606L953 607L952 606M970 606L971 607L970 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M983 606L984 607L983 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M993 606L994 607L993 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M994 606L995 607L994 606M1007 606L1008 607L1007 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1008 606L1009 607L1008 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1151 606L1152 607L1151 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1169 606L1170 607L1169 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1170 606L1171 607L1170 606M1181 606L1182 607L1181 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1182 606L1183 607L1182 606M1200 606L1201 607L1200 606M1229 606L1230 607L1229 606M1241 606L1242 607L1241 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1258 606L1259 607L1258 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M18 607L18 614L19 614L18 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M91 607L91 614L92 614L91 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M119 607L120 608L119 607M134 607L135 608L134 607M151 607L152 608L151 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M169 607L170 608L169 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M200 607L201 608L200 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M208 607L209 608L208 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M225 607L226 608L225 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M269 607L270 608L269 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M282 607L283 608L282 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M352 607L353 608L352 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M367 607L368 608L367 607M383 607L384 608L383 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M391 607L392 608L391 607M423 607L424 608L423 607M499 607L500 608L499 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M517 607L518 608L517 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M532 607L533 608L532 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M577 607L578 608L577 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M590 607L591 608L590 607M607 607L608 608L607 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M647 607L647 611L648 611L647 607M683 607L684 608L683 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M700 607L701 608L700 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M701 607L702 608L701 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M716 607L717 608L716 607M733 607L734 608L733 607M773 607L774 608L773 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M781 607L782 608L781 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M797 607L798 608L797 607M813 607L814 608L813 607M847 607L847 615L848 615L847 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M938 607L939 608L938 607M953 607L954 608L953 607M971 607L972 608L971 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M984 607L985 608L984 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M992 607L993 608L992 607M1024 607L1025 608L1024 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1168 607L1169 608L1168 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1183 607L1184 608L1183 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1201 607L1202 608L1201 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1228 607L1229 608L1228 607M1242 607L1243 608L1242 607M1258 607L1258 610L1259 610L1258 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M76 608L76 612L77 612L76 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M117 608L118 609L117 608M134 608L135 609L134 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M150 608L151 609L150 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M170 608L171 609L170 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M201 608L202 609L201 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M207 608L208 609L207 608M226 608L227 609L226 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M268 608L269 609L268 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M283 608L284 609L283 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M367 608L368 609L367 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M384 608L385 609L384 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M390 608L391 609L390 608M408 608L409 609L408 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M423 608L423 611L424 611L423 608M499 608L500 609L499 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M533 608L534 609L533 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M550 608L551 609L550 608M576 608L577 609L576 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M591 608L592 609L591 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M607 608L608 609L607 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M699 608L700 609L699 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M717 608L718 609L717 608M734 608L735 609L734 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M779 608L780 609L779 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M798 608L799 609L798 608M813.333 608.667L813.667 609.333L813.333 608.667M862.333 608.667L862.667 609.333L862.333 608.667M920 608L921 609L920 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M937 608L938 609L937 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M971 608L972 609L971 608M985 608L986 609L985 608M990 608L991 609L990 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1009 608L1010 609L1009 608M1024 608L1025 609L1024 608M1150 608L1151 609L1150 608M1167 608L1168 609L1167 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1227 608L1228 609L1227 608M1243 608L1244 609L1243 608M116 609L117 610L116 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M133 609L134 610L133 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M149 609L150 610L149 609M171 609L172 610L171 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M202 609L203 610L202 609M206 609L207 610L206 609M226 609L227 610L226 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M241.333 609.667L241.667 610.333L241.333 609.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M267 609L268 610L267 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M283 609L284 610L283 609M299 609L299 644L300 644L299 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M351 609L352 610L351 609M366 609L367 610L366 609M385 609L386 610L385 609M388 609L389 610L388 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M389 609L390 610L389 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M409.333 609.667L409.667 610.333L409.333 609.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M498 609L499 610L498 609M515 609L516 610L515 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M534 609L535 610L534 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M575 609L576 610L575 609M592 609L593 610L592 609M607 609L607 644L594 644L594 645L606.397 643.972L608 635L607 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M682 609L683 610L682 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M698 609L699 610L698 609M718 609L719 610L718 609M734 609L735 610L734 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M774 609L775 610L774 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M778 609L779 610L778 609M920 609L921 610L920 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M936 609L937 610L936 609M972 609L973 610L972 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M986 609L987 610L986 609M989 609L990 610L989 609M1024 609L1024 641L1025 641L1024 609M1150 609L1151 610L1150 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1166 609L1167 610L1166 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1185 609L1186 610L1185 609M1202 609L1203 610L1202 609M1227 609L1228 610L1227 609M1243 609L1244 610L1243 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M115 610L116 611L115 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M133.333 610.667L133.667 611.333L133.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M171 610L172 611L171 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M203 610L204 611L203 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M205 610L206 611L205 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M226 610L227 611L226 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M284 610L285 611L284 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M350 610L351 611L350 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M365 610L366 611L365 610M387 610L388 611L387 610M498.333 610.667L498.667 611.333L498.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M514 610L515 611L514 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M535 610L536 611L535 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M551 610L552 611L551 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M575 610L576 611L575 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M682 610L683 611L682 610M719 610L720 611L719 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M775 610L776 611L775 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M777 610L778 611L777 610M799.333 610.667L799.667 611.333L799.333 610.667M813 610L813 644L801 644L801 645L812.397 643.972L814 635L813 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M862 610L863 611L862 610M919 610L920 611L919 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M935 610L936 611L935 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M956 610L957 611L956 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M972 610L973 611L972 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M986 610L987 611L986 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M988 610L989 611L988 610M1010 610L1011 611L1010 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1149 610L1150 611L1149 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1165 610L1166 611L1165 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1186 610L1187 611L1186 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1202.33 610.667L1202.67 611.333L1202.33 610.667M1226 610L1227 611L1226 610M1244 610L1245 611L1244 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M115 611L116 612L115 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M148 611L149 612L148 611M172 611L173 612L172 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M204 611L205 612L204 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M241 611L241 614L242 614L241 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M266 611L267 612L266 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M284 611L285 612L284 611M365 611L366 612L365 611M386.667 611.333L387.333 611.667L386.667 611.333M409.333 611.667L409.667 612.333L409.333 611.667M496 611L496 613L498 613L496 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 611L514 612L513 611M551.333 611.667L551.667 612.333L551.333 611.667M593.333 611.667L593.667 612.333L593.333 611.667M647 611L647 629L648 629L647 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M697 611L698 612L697 611M735 611L736 612L735 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M776 611L777 612L776 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M862 611L862 614L863 614L862 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M919.333 611.667L919.667 612.333L919.333 611.667M957 611L958 612L957 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M987 611L988 612L987 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1010.33 611.667L1010.67 612.333L1010.33 611.667M1149 611L1150 612L1149 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1187 611L1188 612L1187 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1226 611L1227 612L1226 611M1244 611L1245 612L1244 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M33.3333 612.667L33.6667 613.333L33.3333 612.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M76 612L76 615L77 615L76 612M114 612L115 613L114 612M133.333 612.667L133.667 613.333L133.333 612.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M148 612L149 613L148 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M172 612L173 613L172 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M227 612L227 615L228 615L227 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M266.333 612.667L266.667 613.333L266.333 612.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M349 612L350 613L349 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M364 612L365 613L364 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M513 612L514 613L513 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M536 612L537 613L536 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M681 612L682 613L681 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M720 612L721 613L720 612M735 612L736 613L735 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M799.333 612.667L799.667 613.333L799.333 612.667M934 612L935 613L934 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M973 612L974 613L973 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1149 612L1150 613L1149 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1164 612L1165 613L1164 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1226 612L1227 613L1226 612M1244 612L1245 613L1244 612M114 613L115 614L114 613M172 613L173 614L172 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M285 613C285 618.98 281.761 640.137 286.603 643.972C289.389 646.179 295.643 645 299 645L299 644L286 644L285 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M348 613L349 614L348 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M363 613L364 614L363 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M497.333 613.667L497.667 614.333L497.333 613.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M512 613L513 614L512 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M593.333 613.667L593.667 614.333L593.333 613.667M681 613L682 614L681 613M696 613L697 614L696 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M720 613L721 614L720 613M843 613L841 622C843.963 619.744 844.378 616.38 843 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M958 613L959 614L958 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M973.333 613.667L973.667 614.333L973.333 613.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1010.33 613.667L1010.67 614.333L1010.33 613.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1188 613L1189 614L1188 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1203 613L1204 614L1203 613M18.3333 614.667L18.6667 615.333L18.3333 614.667M33.3333 614.667L33.6667 615.333L33.3333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M147.333 614.667L147.667 615.333L147.333 614.667M241 614L241 644L229 644L227 640C228.847 644.353 238.494 648.581 241.397 642.682C244.103 637.181 243.32 619.529 241 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M266 614L266 638L267 638L266 614M363 614L364 615L363 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M512 614L513 615L512 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M537 614L538 615L537 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M552.333 614.667L552.667 615.333L552.333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M681 614L681 618L682 618L681 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M696 614L697 615L696 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M721.333 614.667L721.667 615.333L721.333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M799 614L800 615L799 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M862.333 614.667L862.667 615.333L862.333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M918.333 614.667L918.667 615.333L918.333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M933 614L934 615L933 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M958 614L959 615L958 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1148.33 614.667L1148.67 615.333L1148.33 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1163 614L1164 615L1163 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1188 614L1189 615L1188 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1203 614L1203 623L1204 623L1203 614M113.333 615.667L113.667 616.333L113.333 615.667M173 615L173 620L174 620L173 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M209 615L210 616L209 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M210.667 615.333L211.333 615.667L210.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M212 615L212 616L227 616L212 615M347 615L348 616L347 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M362 615L363 616L362 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M391 615L392 616L391 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M392 615L392 616L395 616L392 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M395 615L395 616L399 616L395 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M399 615L400 616L399 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M400 615L400 616L408 616L400 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M408 615L409 616L408 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M409 615L410 616L409 615M497 615L497 622L498 622L497 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M512 615L513 616L512 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M537 615L538 616L537 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M593 615L593 643L594 643L593 615M780.667 615.333L781.333 615.667L780.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M782 615L782 616L786 616L782 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M786 615L786 616L792 616L786 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M792.667 615.333L793.333 615.667L792.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M794 615L794 616L797 616L794 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M797 615L798 616L797 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M798.667 615.333L799.333 615.667L798.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M933 615L934 616L933 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M958 615L959 616L958 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M973 615L973 623L974 623L973 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M992.667 615.333L993.333 615.667L992.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M994.667 615.333L995.333 615.667L994.667 615.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M996 615L996 616L1000 616L996 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1000 615L1000 616L1008 616L1000 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1008 615L1009 616L1008 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1009 615L1010 616L1009 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1010 615L1011 616L1010 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1163 615L1164 616L1163 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1188 615L1189 616L1188 615M1244 615L1245 616L1244 615M18 616L19 617L18 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M33 616L34 617L33 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M75 616L76 617L75 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M90.3333 616.667L90.6667 617.333L90.3333 616.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M147 616L147 620L148 620L147 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M205 616L206 617L205 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M206.667 616.333L207.333 616.667L206.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M346 616L347 617L346 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M361 616L362 617L361 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M388 616L389 617L388 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M389 616L390 617L389 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M537.333 616.667L537.667 617.333L537.333 616.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M552.333 616.667L552.667 617.333L552.333 616.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 616L695 622L696 622L695 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M721 616L722 617L721 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M736.333 616.667L736.667 617.333L736.333 616.667M777 616L778 617L777 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M778.667 616.333L779.333 616.667L778.667 616.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M918 616L918 622L919 622L918 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M933.333 616.667L933.667 617.333L933.333 616.667M988 616L989 617L988 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M989 616L990 617L989 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M990 616L991 617L990 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1148 616L1148 622L1149 622L1148 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1163 616L1163 622L1164 622L1163 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M75 617L76 618L75 617M113 617L113 644L114 644L113 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M132.333 617.667L132.667 618.333L132.333 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M203 617L204 618L203 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M345 617L346 618L345 617M361 617L362 618L361 617M385 617L386 618L385 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M386 617L387 618L386 617M511 617L511 621L512 621L511 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M721 617L721 621L722 621L721 617M775 617L776 618L775 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M776 617L777 618L776 617M848.333 617.667L848.667 618.333L848.333 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M863 617L864 618L863 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M959 617L959 621L960 621L959 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M986 617L987 618L986 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M987 617L988 618L987 617M1189 617L1189 621L1190 621L1189 617M19.3333 618.667L19.6667 619.333L19.3333 618.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M34 618L35 619L34 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M75 618L76 619L75 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M90 618L91 619L90 618M201 618L202 619L201 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M345 618L346 619L345 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M360 618L361 619L360 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M384 618L385 619L384 618M552.333 618.667L552.667 619.333L552.333 618.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M736.333 618.667L736.667 619.333L736.333 618.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M773 618L774 619L773 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M774 618L775 619L774 618M863 618L864 619L863 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M984 618L985 619L984 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M985 618L986 619L985 618M34 619L35 620L34 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M74 619L75 620L74 619M90 619L91 620L90 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M200 619L201 620L200 619M344 619L345 620L344 619M359 619L360 620L359 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M382 619L383 620L382 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M772 619L773 620L772 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M848 619L849 620L848 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M983 619L984 620L983 619M19 620L20 621L19 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M74 620L75 621L74 620M147 620L148 621L147 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M343 620L344 621L343 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M381 620L382 621L381 620M552.333 620.667L552.667 621.333L552.333 620.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M681 620L681 624L682 624L681 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M736.333 620.667L736.667 621.333L736.333 620.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M771 620L772 621L771 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M864 620L865 621L864 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M933.333 620.667L933.667 621.333L933.333 620.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M982 620L983 621L982 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M35 621L36 622L35 621M89 621L90 622L89 621M133 621L133 624L134 624L133 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M172 621L173 622L172 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M198 621L199 622L198 621M343 621L344 622L343 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M358 621L359 622L358 621M380 621L381 622L380 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M474 621L474 635L475 635L474 621M537 621L538 622L537 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M721 621L722 622L721 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M770 621L771 622L770 621M849 621L850 622L849 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M903.667 621.333L904.333 621.667L903.667 621.333M981 621L982 622L981 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M20 622L21 623L20 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M36 622L37 623L36 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M73 622L74 623L73 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M89 622L90 623L89 622M148 622L149 623L148 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M172.333 622.667L172.667 623.333L172.333 622.667M197 622L198 623L197 622M342 622L343 623L342 622M357 622L358 623L357 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M379 622L380 623L379 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M497.333 622.667L497.667 623.333L497.333 622.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M512 622L513 623L512 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M537 622L538 623L537 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M552 622L553 623L552 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M721.333 622.667L721.667 623.333L721.333 622.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M769 622L770 623L769 622M849 622L850 623L849 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M865 622L866 623L865 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M902 622L903 623L902 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M905 622L906 623L905 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M918.333 622.667L918.667 623.333L918.333 622.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M933 622L934 623L933 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M958 622L959 623L958 622M980 622L981 623L980 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1074 622L1074 640L1075 640L1074 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1148.33 622.667L1148.67 623.333L1148.33 622.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1163 622L1164 623L1163 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1188 622L1189 623L1188 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M20 623L21 624L20 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M36 623L37 624L36 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M72 623L73 624L72 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M88 623L89 624L88 623M148 623L149 624L148 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M196 623L197 624L196 623M341 623L342 624L341 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M379 623L380 624L379 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M512 623L513 624L512 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M537 623L538 624L537 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M696 623L697 624L696 623M849 623L850 624L849 623M866 623L867 624L866 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M902 623L903 624L902 623M906 623L907 624L906 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M907 623L908 624L907 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M933 623L934 624L933 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M958 623L959 624L958 623M973.333 623.667L973.667 624.333L973.333 623.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M980 623L981 624L980 623M1163 623L1164 624L1163 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1188 623L1189 624L1188 623M1203 623L1204 624L1203 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M21 624L22 625L21 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M37 624L38 625L37 624M88 624L89 625L88 624M133 624L134 625L133 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M149 624L150 625L149 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M171 624L172 625L171 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M196 624L197 625L196 624M215 624L215 625L225 625L215 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M356 624L357 625L356 624M378 624L379 625L378 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M398 624L398 625L405 625L398 624M407 624L408 625L407 624M409 624L410 625L409 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M497 624L498 625L497 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M512 624L513 625L512 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M681 624L682 625L681 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M696 624L697 625L696 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M720 624L721 625L720 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M735.333 624.667L735.667 625.333L735.333 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M768 624L769 625L768 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M788.667 624.333L789.333 624.667L788.667 624.333M791.667 624.333L792.333 624.667L791.667 624.333M794.667 624.333L795.333 624.667L794.667 624.333M797.667 624.333L798.333 624.667L797.667 624.333M850 624L851 625L850 624M901 624L902 625L901 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M908 624L909 625L908 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M958 624L959 625L958 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M979 624L980 625L979 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1000 624L1000 625L1010 625L1000 624M1102 624L1103 625L1102 624M1188 624L1189 625L1188 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1203 624L1204 625L1203 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M21 625L22 626L21 625M38 625L39 626L38 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M71 625L72 626L71 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M133 625L134 626L133 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M149 625L150 626L149 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M195 625L196 626L195 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M212 625L213 626L212 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M213 625L214 626L213 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M227 625C224.336 625 221.664 624.944 219 625.015C202.63 625.451 215.894 641.309 224.297 631.607C225.925 629.728 226.436 627.339 227 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M227.333 625.667L227.667 626.333L227.333 625.667M340 625L341 626L340 625M355 625L356 626L355 625M378 625L379 626L378 625M394 625L395 626L394 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M395 625L396 626L395 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M396.667 625.333L397.333 625.667L396.667 625.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M409 625C406.67 625 404.326 624.932 401.998 625.039C381.407 625.99 406.725 645.41 409 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M409.333 625.667L409.667 626.333L409.333 625.667M513 625L514 626L513 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M536 625L537 626L536 625M551 625L552 626L551 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M681 625L682 626L681 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M720 625L721 626L720 625M768 625L769 626L768 625M784 625L785 626L784 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M785 625L786 626L785 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M799 625C796.337 625 793.662 624.932 791 625.015C774.49 625.535 789.104 642.365 797.258 630.896C798.559 629.065 798.761 627.149 799 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M799.333 625.667L799.667 626.333L799.333 625.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M850 625L851 626L850 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M867 625L868 626L867 625M900 625L901 626L900 625M909 625L910 626L909 625M919 625L920 626L919 625M934 625L935 626L934 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M957 625L958 626L957 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M979 625L980 626L979 625M995 625L996 626L995 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M996.667 625.333L997.333 625.667L996.667 625.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M1010 625C1007.34 625 1004.66 624.905 1002 625.04C985.629 625.872 1000.25 642.158 1008.26 630.896C1009.56 629.065 1009.76 627.149 1010 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1010.33 625.667L1010.67 626.333L1010.33 625.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1149 625L1150 626L1149 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1164 625L1165 626L1164 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1187 625L1188 626L1187 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M39 626L40 627L39 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M70 626L71 627L70 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M87 626L88 627L87 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M134 626L135 627L134 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M150 626L151 627L150 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M170 626L171 627L170 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M195 626L196 627L195 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M210 626L211 627L210 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M339 626L340 627L339 626M393 626L394 627L393 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M498 626L499 627L498 626M513 626L514 627L513 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M551 626L552 627L551 626M697 626L698 627L697 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M719 626L720 627L719 626M735 626L736 627L735 626M767 626L768 627L767 626M783 626L784 627L783 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M851 626L852 627L851 626M868 626L869 627L868 626M899 626L900 627L899 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M911 626L912 627L911 626M919 626L920 627L919 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M957 626L958 627L957 626M972 626L973 627L972 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M994 626L995 627L994 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1149 626L1150 627L1149 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1187 626L1188 627L1187 626M1202 626L1203 627L1202 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M22 627L23 628L22 627M40 627L41 628L40 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M69 627L70 628L69 627M86 627L87 628L86 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M134 627L135 628L134 627M151 627L152 628L151 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M169 627L170 628L169 627M195.333 627.667L195.667 628.333L195.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M226.333 627.667L226.667 628.333L226.333 627.667M354 627L355 628L354 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M392 627L393 628L392 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M409 627L410 628L409 627M498 627L499 628L498 627M514 627L515 628L514 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M535 627L536 628L535 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M551 627L552 628L551 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M682 627L683 628L682 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M698 627L699 628L698 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M719 627L720 628L719 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M767 627L768 628L767 627M782 627L783 628L782 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M799.333 627.667L799.667 628.333L799.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M851 627L852 628L851 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M869 627L870 628L869 627M898 627L899 628L898 627M912 627L913 628L912 627M935 627L936 628L935 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M956 627L957 628L956 627M972 627L973 628L972 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M978 627L979 628L978 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M993 627L994 628L993 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1010.33 627.667L1010.67 628.333L1010.33 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1103 627L1104 628L1103 627M1149 627L1150 628L1149 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1165 627L1166 628L1165 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1186 627L1187 628L1186 627M1202 627L1203 628L1202 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M23 628L24 629L23 628M41 628L42 629L41 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M67 628L68 629L67 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M86 628L87 629L86 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M152 628L153 629L152 628M168 628L169 629L168 628M209 628L210 629L209 628M338 628L339 629L338 628M353 628L354 629L353 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M377 628L377 633L378 633L377 628M392 628L393 629L392 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M409 628L410 629L409 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M498 628L499 629L498 628M515 628L516 629L515 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M534 628L535 629L534 628M550 628L551 629L550 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M682 628L683 629L682 628M699 628L700 629L699 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M718 628L719 629L718 628M734 628L735 629L734 628M767 628L767 632L768 632L767 628M852 628L853 629L852 628M870 628L871 629L870 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M871 628L872 629L871 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M897 628L898 629L897 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M914.333 628.667L914.667 629.333L914.333 628.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M920 628L921 629L920 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M936 628L937 629L936 628M955 628L956 629L955 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M972 628L973 629L972 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M978 628L978 633L979 633L978 628M1103 628L1104 629L1103 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1150 628L1151 629L1150 628M1166 628L1167 629L1166 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1185 628L1186 629L1185 628M23 629L24 630L23 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M42 629L43 630L42 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M43 629L44 630L43 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M66 629L67 630L66 629M85 629L86 630L85 629M135 629L136 630L135 629M153 629L154 630L153 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M154 629L155 630L154 629M166 629L167 630L166 629M209.333 629.667L209.667 630.333L209.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M226 629L227 630L226 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M309 629L309 640L310 640L309 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M337 629L338 630L337 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M408 629L409 630L408 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M437.333 629.667L437.667 630.333L437.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M452 629L453 630L452 629M499 629L500 630L499 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M516 629L517 630L516 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M533 629L534 630L533 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M550 629L551 630L550 629M647 629L648 630L647 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M662 629L663 630L662 629M683 629L684 630L683 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M700 629L701 630L700 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M717 629L718 630L717 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M734 629L735 630L734 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M781.333 629.667L781.667 630.333L781.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M798 629L799 630L798 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M872 629L873 630L872 629M895 629L896 630L895 629M920 629L921 630L920 629M937 629L938 630L937 629M954 629L955 630L954 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M971 629L972 630L971 629M992.333 629.667L992.667 630.333L992.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1009 629L1010 630L1009 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1103 629L1104 630L1103 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1150 629L1151 630L1150 629M1167 629L1168 630L1167 629M1184 629L1185 630L1184 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1201 629L1202 630L1201 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M24 630L25 631L24 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M44 630L45 631L44 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M45 630L46 631L45 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M64 630L65 631L64 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M135 630L136 631L135 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M156 630L157 631L156 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M157.667 630.333L158.333 630.667L157.667 630.333M162.667 630.333L163.333 630.667L162.667 630.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M164 630L165 631L164 630M195 630L195 634L196 634L195 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M225 630L226 631L225 630M336 630L337 631L336 630M352 630L353 631L352 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M408 630L409 631L408 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M453 630L454 631L453 630M499 630L500 631L499 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M517 630L518 631L517 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M532 630L533 631L532 630M549 630L550 631L549 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M647.333 630.667L647.667 631.333L647.333 630.667M663 630L664 631L663 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M683 630L684 631L683 630M701 630L702 631L701 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M715 630L716 631L715 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M716 630L717 631L716 630M733 630L734 631L733 630M798 630L799 631L798 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M853 630L854 631L853 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M873 630L874 631L873 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M874 630L875 631L874 630M893 630L894 631L893 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M894 630L895 631L894 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M913 630L914 631L913 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M921 630L922 631L921 630M938 630L939 631L938 630M953 630L954 631L953 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M971 630L972 631L971 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1009 630L1010 631L1009 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1104 630L1105 631L1104 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1151 630L1152 631L1151 630M1168 630L1169 631L1168 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1169 630L1170 631L1169 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1183 630L1184 631L1183 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1201 630L1202 631L1201 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M25 631L26 632L25 631M46 631L47 632L46 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M47 631L48 632L47 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M48 631L49 632L48 631M61 631L62 632L61 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M62 631L63 632L62 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M84 631L85 632L84 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M136 631L137 632L136 631M209 631L210 632L209 631M225 631L226 632L225 631M336 631L337 632L336 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M351 631C354.989 635.565 369.132 633 375 633L375 632L351 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M392 631L393 632L392 631M407 631L408 632L407 631M437 631L438 632L437 631M454 631L455 632L454 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M500 631L501 632L500 631M518 631L519 632L518 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M519 631L520 632L519 631M530 631L531 632L530 631M549 631L550 632L549 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M664 631L665 632L664 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M702 631L703 632L702 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M703 631L704 632L703 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M714 631L715 632L714 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M733 631L734 632L733 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M797 631L798 632L797 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M854 631L855 632L854 631M876 631L877 632L876 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M877 631L878 632L877 631M890 631L891 632L890 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M891 631L892 632L891 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M912 631L913 632L912 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M921 631L922 632L921 631M940 631L941 632L940 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M951 631L952 632L951 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M952 631L953 632L952 631M970 631L971 632L970 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M993 631L994 632L993 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1008 631L1009 632L1008 631M1105 631L1106 632L1105 631M1151 631L1152 632L1151 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1170 631L1171 632L1170 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1171 631L1172 632L1171 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1181 631L1182 632L1181 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1182 631L1183 632L1182 631M1200 631L1201 632L1200 631M26 632L27 633L26 632M50.6667 632.333L51.3333 632.667L50.6667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M52 632L52 633L55 633L52 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M55 632L56 633L55 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M56.6667 632.333L57.3333 632.667L56.6667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M58.6667 632.333L59.3333 632.667L58.6667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M83 632L84 633L83 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M137 632L138 633L137 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M210 632L211 633L210 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M224 632L225 633L224 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M335 632L336 633L335 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M392 632L393 633L392 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M406 632L407 633L406 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M455 632L456 633L455 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M456 632L457 633L456 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M457 632L458 633L457 632M463 632L463 633L466 633L463 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M466 632L467 633L466 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M467 632L468 633L467 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M521 632L522 633L521 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M522.667 632.333L523.333 632.667L522.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M524.667 632.333L525.333 632.667L524.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M526 632L527 633L526 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M527.667 632.333L528.333 632.667L527.667 632.333M548 632L549 633L548 632M665 632L666 633L665 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M666 632L667 633L666 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M667.667 632.333L668.333 632.667L667.667 632.333M674 632L674 633L678 633L674 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M684 632L685 633L684 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M704.667 632.333L705.333 632.667L704.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M706.667 632.333L707.333 632.667L706.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M708.667 632.333L709.333 632.667L708.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M710 632L711 633L710 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M711.667 632.333L712.333 632.667L711.667 632.333M732 632L733 633L732 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M767.333 632.667L767.667 633.333L767.333 632.667M782 632L783 633L782 632M796 632L797 633L796 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M855 632L856 633L855 632M879.667 632.333L880.333 632.667L879.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M881 632L881 633L887 633L881 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M887.667 632.333L888.333 632.667L887.667 632.333M922 632L923 633L922 632M942.667 632.333L943.333 632.667L942.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M944.667 632.333L945.333 632.667L944.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M946 632L947 633L946 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M947.667 632.333L948.333 632.667L947.667 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M949 632L950 633L949 632M993 632L994 633L993 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1007 632L1008 633L1007 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1089 632L1090 633L1089 632M1107 632L1108 633L1107 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1108 632L1109 633L1108 632M1115 632L1116 633L1115 632M1117.67 632.333L1118.33 632.667L1117.67 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1152 632L1153 633L1152 632M1172.67 632.333L1173.33 632.667L1172.67 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1174 632L1174 633L1178 633L1174 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1178.67 632.333L1179.33 632.667L1178.67 632.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M26 633L27 634L26 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M82 633L83 634L82 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M137 633L138 634L137 633M211 633L212 634L211 633M222 633L223 634L222 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M223 633L224 634L223 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M334 633L335 634L334 633M375 633L376 634L375 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M393 633L394 634L393 633M405 633L406 634L405 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M438 633L439 634L438 633M467 633L467 645L468 645L467 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M501 633L502 634L501 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M548 633L549 634L548 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M648 633L649 634L648 633M677 633L677 645L678 645L677 633M685 633L686 634L685 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M783 633L784 634L783 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M795 633L796 634L795 633M856 633L858 635L856 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M911 633L912 634L911 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M922 633L923 634L922 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M969 633L970 634L969 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M978 633L979 634L978 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M994 633L995 634L994 633M1006 633L1007 634L1006 633M1089 633L1090 634L1089 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1119 633L1120 634L1119 633M1152 633L1153 634L1152 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1199 633L1200 634L1199 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M27 634L28 635L27 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M81 634L82 635L81 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M138 634L139 635L138 634M195 634L196 635L195 634M212 634L213 635L212 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M213 634L214 635L213 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M220 634L221 635L220 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M221 634L222 635L221 634M334 634L335 635L334 634M378.333 634.667L378.667 635.333L378.333 634.667M394 634L395 635L394 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M395 634L396 635L395 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M402 634L403 635L402 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M403 634L404 635L403 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M404 634L405 635L404 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M438 634L439 635L438 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M502 634L503 635L502 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M547 634L548 635L547 634M648 634L649 635L648 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M731 634L732 635L731 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M784 634L785 635L784 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M785 634L786 635L785 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M793 634L794 635L793 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M856 634L857 635L856 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M910 634L911 635L910 634M923 634L924 635L923 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M968 634L969 635L968 634M995 634L996 635L995 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M996 634L997 635L996 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1004 634L1005 635L1004 634M1153 634L1154 635L1153 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1198 634L1199 635L1198 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M28 635L29 636L28 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M80 635L81 636L80 635M139 635L140 636L139 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M195 635L196 636L195 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M214 635L214 636L219 636L214 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M333 635L334 636L333 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M375 635L376 636L375 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M397 635L397 636L402 636L397 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M438 635L439 636L438 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M546 635L547 636L546 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M686 635L687 636L686 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M730 635L731 636L730 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M768 635L769 636L768 635M786 635L786 636L792 636L786 635M858 635L859 636L858 635M909 635L910 636L909 635M924 635L925 636L924 635M967 635L968 636L967 635M979 635L980 636L979 635M998 635L998 636L1002 636L998 635M1090 635L1091 636L1090 635M1154 635L1155 636L1154 635M1197 635L1198 636L1197 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M29 636L30 637L29 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M79 636L80 637L79 636M140 636L141 637L140 636M196 636L197 637L196 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M332 636L333 637L332 636M378 636L379 637L378 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M439 636L440 637L439 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M503 636L504 637L503 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M545 636L546 637L545 636M649 636L650 637L649 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M687 636L688 637L687 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M729 636L730 637L729 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M768 636L769 637L768 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M859 636L861 638L859 636M908 636L909 637L908 636M925 636L926 637L925 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M967 636L968 637L967 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M979 636L980 637L979 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1090 636L1091 637L1090 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1155 636L1156 637L1155 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1197 636L1198 637L1197 636M30 637L31 638L30 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M31 637L32 638L31 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M78 637L79 638L78 637M141 637L142 638L141 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M172 637L173 638L172 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M196 637L197 638L196 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M375 637L376 638L375 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M379 637L380 638L379 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M424 637L424 643L425 643L424 637M439 637L440 638L439 637M504 637L505 638L504 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M544 637L545 638L544 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M688 637L689 638L688 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M728 637L729 638L728 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M859 637L860 638L859 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M907 637L908 638L907 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M926 637L927 638L926 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M966 637L967 638L966 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M980 637L981 638L980 637M1091 637L1092 638L1091 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1119 637L1119 642L1120 642L1119 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1156 637L1157 638L1156 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1196 637L1197 638L1196 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M32 638L33 639L32 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M77 638L78 639L77 638M142 638L143 639L142 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M171 638L172 639L171 638M197 638L198 639L197 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M266 638L266 641L267 641L266 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M331 638L332 639L331 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M379 638L380 639L379 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M440 638L441 639L440 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M543 638L544 639L543 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M650 638L651 639L650 638M689 638L690 639L689 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M727 638L728 639L727 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M769 638L770 639L769 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M861 638L862 639L861 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M906 638L907 639L906 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M927 638L928 639L927 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M965 638L966 639L965 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M980 638L981 639L980 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1157 638L1158 639L1157 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1195 638L1196 639L1195 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M33 639L34 640L33 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M75 639L76 640L75 639M144 639L145 640L144 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M170 639L171 640L170 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M197 639L198 640L197 639M330 639L331 640L330 639M375.333 639.667L375.667 640.333L375.333 639.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M380 639L381 640L380 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M441 639L442 640L441 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M506 639L507 640L506 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M542 639L543 640L542 639M651 639L652 640L651 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M690 639L691 640L690 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M726 639L727 640L726 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M770 639L771 640L770 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M862 639L863 640L862 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M904 639L905 640L904 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M905 639L906 640L905 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M928 639L929 640L928 639M963 639L964 640L963 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M964 639L965 640L964 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M981 639L982 640L981 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1092 639L1093 640L1092 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1158 639L1159 640L1158 639M1193 639L1194 640L1193 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1194 639L1195 640L1194 639M34 640L35 641L34 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M35 640L36 641L35 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M74 640L75 641L74 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M145 640L146 641L145 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M146 640L147 641L146 640M168 640L169 641L168 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M169 640L170 641L169 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M198 640L199 641L198 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M381 640L382 641L381 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M410 640L411 641L410 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M442 640L443 641L442 640M508 640L509 641L508 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M541 640L542 641L541 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M652 640L653 641L652 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M691 640L692 641L691 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M692 640L693 641L692 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M725 640L726 641L725 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M771 640L772 641L771 640M799 640L800 641L799 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M800 640L801 641L800 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M864 640L865 641L864 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M903 640L904 641L903 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M929 640L930 641L929 640M962 640L963 641L962 640M982 640L983 641L982 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1011 640L1012 641L1011 640M1093 640L1094 641L1093 640M1159 640L1160 641L1159 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1192 640L1193 641L1192 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M36 641L37 642L36 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M72 641L73 642L72 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M73 641L74 642L73 641M147 641L148 642L147 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M148 641L149 642L148 641M166 641L167 642L166 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M167 641L168 642L167 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M199 641L200 642L199 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M226 641L227 642L226 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M251.333 641.667L251.667 642.333L251.333 641.667M266.333 641.667L266.667 642.333L266.333 641.667M309 641L310 642L309 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M382 641L383 642L382 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M409 641L410 644L411 644L409 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M410 641L411 642L410 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M443 641L444 642L443 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M509 641L510 642L509 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M539 641L540 642L539 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M540 641L541 642L540 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M653 641L654 642L653 641M693 641L694 642L693 641M723 641L724 642L723 641M772 641L773 642L772 641M798 641L799 642L798 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M800 641L800 645L801 645L800 641M865 641L866 642L865 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M866 641L867 642L866 641M901 641L902 642L901 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M902 641L903 642L902 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M930 641L931 642L930 641M961 641L962 642L961 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M983 641L984 642L983 641M1009 641L1010 642L1009 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1010 641L1011 645L1012 645L1010 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1074 641L1075 642L1074 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1094 641L1095 642L1094 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1160 641L1161 642L1160 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1161 641L1162 642L1161 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1191 641L1192 642L1191 641M38 642L39 643L38 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M70 642L71 643L70 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M71 642L72 643L71 642M150 642L151 643L150 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M151 642L152 643L151 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M152.667 642.333L153.333 642.667L152.667 642.333M161 642L161 643L164 643L161 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M164 642L165 643L164 642M172 642L173 643L172 642M200 642L201 643L200 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M201 642L202 643L201 642M224 642L225 643L224 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M225 642L226 643L225 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M329.333 642.667L329.667 643.333L329.333 642.667M375.333 642.667L375.667 643.333L375.333 642.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M383 642L384 643L383 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M407 642L408 643L407 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M444 642L445 643L444 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M474 642L474 645L475 645L474 642M510 642L511 643L510 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M511 642L512 643L511 642M537 642L538 643L537 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M538 642L539 643L538 642M654 642L655 643L654 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M694 642L695 643L694 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M695 642L696 643L695 642M721 642L722 643L721 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M722 642L723 643L722 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M773 642L774 643L773 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M797 642L798 643L797 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M867 642L868 643L867 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M868 642L869 643L868 642M899 642L900 643L899 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M900 642L901 643L900 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M932 642L933 643L932 642M959 642L960 643L959 642M984 642L985 643L984 642M1008 642L1009 643L1008 642M1024 642L1025 643L1024 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1095 642L1096 643L1095 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1096 642L1097 643L1096 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1162 642L1163 643L1162 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1189 642L1190 643L1189 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1259.33 642.667L1259.67 643.333L1259.33 642.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M40 643L41 644L40 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M41 643L42 644L41 643M68 643L69 644L68 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M69 643L70 644L69 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M99 643L113 645L113 644L99 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M155 643L155 644L160 644L155 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M172 643L173 644L172 643M202 643L203 644L202 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M223 643L224 644L223 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M266 643L267 644L266 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M309 643L310 644L309 643M384 643L385 644L384 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M385 643L386 644L385 643M405 643L406 644L405 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M406 643L407 644L406 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M446 643L447 644L446 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M489 643L490 644L489 643M512 643L513 644L512 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M513 643L514 644L513 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M536 643L537 644L536 643M593 643L594 644L593 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M656 643L657 644L656 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M696 643L697 644L696 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M697 643L698 644L697 643M719 643L720 644L719 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M720 643L721 644L720 643M774 643L775 644L774 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M775 643L776 644L775 643M795 643L796 644L795 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M869 643L870 644L869 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M870 643L871 644L870 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M897 643L898 644L897 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M898 643L899 644L898 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M934 643L935 644L934 643M957 643L958 644L957 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M958 643L959 644L958 643M985 643L986 644L985 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M986 643L987 644L986 643M1006 643L1007 644L1006 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1007 643L1008 644L1007 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1097 643L1098 644L1097 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1119 643L1120 644L1119 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1164 643L1165 644L1164 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1187 643L1188 644L1187 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1188 643L1189 644L1188 643M42 644L43 645L42 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M43 644L44 645L43 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M44 644L45 645L44 644M64.6667 644.333L65.3333 644.667L64.6667 644.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M66 644L67 645L66 644M98 644L99 645L98 644M113 644L114 645L113 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M172 644L173 645L172 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M204 644L205 645L204 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M205 644L206 645L205 644M220 644L221 645L220 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M221 644L222 645L221 644M228 644L229 645L228 644M241 644L242 645L241 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M252 644L252 645L266 645L252 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M266 644L267 645L266 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M285 644L286 645L285 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M310 644L310 645L324 645L310 644M330 644L330 645L375 645C363.299 640.09 342.742 644 330 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M386 644L387 645L386 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M387 644L388 645L387 644M403 644L404 645L403 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M404 644L405 645L404 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M411 644L411 645L424 645L411 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M448 644L449 645L448 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M449 644L450 645L449 644M475 644L475 645L489 645L475 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M515 644L516 645L515 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M516 644L517 645L516 644M532.667 644.333L533.333 644.667L532.667 644.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M534 644L535 645L534 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M560 644L561 645L560 644M574 644L575 645L574 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M593 644L594 645L593 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M607 644L608 645L607 644M658 644L659 645L658 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M659 644L660 645L659 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M698 644L699 645L698 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M699 644L700 645L699 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M700 644L701 645L700 644M716.667 644.333L717.333 644.667L716.667 644.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M718 644L719 645L718 644M776 644L777 645L776 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M777 644L778 645L777 644M792 644L793 645L792 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M793 644L794 645L793 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M794 644L795 645L794 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M813 644L814 645L813 644M872 644L873 645L872 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M873 644L874 645L873 644M893.667 644.333L894.333 644.667L893.667 644.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M895 644L896 645L895 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M936 644L937 645L936 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M937 644L938 645L937 644M954 644L955 645L954 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M955 644L956 645L955 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M987 644L988 645L987 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M988 644L989 645L988 644M1003.67 644.333L1004.33 644.667L1003.67 644.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1005 644L1006 645L1005 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1012 644L1012 645L1025 645L1012 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1035 644L1036 645L1035 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1049 644L1050 645L1049 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1061 644L1061 645L1075 645L1061 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1099 644L1100 645L1099 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1100 644L1101 645L1100 644M1118 644L1119 645L1118 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1126 644L1127 645L1126 644M1140 644L1141 645L1140 644M1166 644L1167 645L1166 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1167 644L1168 645L1167 644M1184 644L1185 645L1184 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1185 644L1186 645L1185 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1212 644L1212 645L1226 645L1212 644M1245 644L1245 645L1259 645L1245 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M46 645L47 646L46 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M47 645L48 646L47 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M48 645L48 646L61 646L48 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M61 645L62 646L61 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M62.6667 645.333L63.3333 645.667L62.6667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M142.667 645.333L143.333 645.667L142.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M171 645L172 646L171 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M186 645L187 646L186 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M206 645L207 646L206 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M207 645L208 646L207 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M208 645L208 646L217 646L208 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M217.667 645.333L218.333 645.667L217.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M219 645L220 646L219 645M389 645L390 646L389 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M390 645L391 646L390 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M391 645L391 646L400 646L391 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M400 645L401 646L400 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M401 645L402 646L401 645M450.667 645.333L451.333 645.667L450.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M452 645L453 646L452 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M453 645L453 646L463 646L453 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M463.667 645.333L464.333 645.667L463.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M465 645L466 646L465 645M518 645L519 646L518 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M519 645L520 646L519 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M520 645L520 646L529 646L520 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M529.667 645.333L530.333 645.667L529.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M531 645L532 646L531 645M660 645L661 646L660 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M661.667 645.333L662.333 645.667L661.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M663 645L663 646L673 646L663 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M673.667 645.333L674.333 645.667L673.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M675 645L676 646L675 645M702 645L703 646L702 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M703 645L704 646L703 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M704 645L704 646L713 646L704 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M713 645L714 646L713 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M714 645L715 646L714 645M779 645L780 646L779 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M780 645L781 646L780 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M781 645L781 646L789 646L781 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M789.667 645.333L790.333 645.667L789.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M791 645L792 646L791 645M875 645L876 646L875 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M876 645L877 646L876 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M877 645L877 646L890 646L877 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M890 645L891 646L890 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M891 645L892 646L891 645M939 645L940 646L939 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M940 645L941 646L940 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M941 645L941 646L950 646L941 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M950.667 645.333L951.333 645.667L950.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M952 645L953 646L952 645M990 645L991 646L990 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M991 645L992 646L991 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M992 645L992 646L1001 646L992 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1001 645L1002 646L1001 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1002 645L1003 646L1002 645M1102 645L1103 646L1102 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1103 645L1104 646L1103 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1104 645L1104 646L1115 646L1104 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1115 645L1116 646L1115 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1116 645L1117 646L1116 645M1169 645L1170 646L1169 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1170 645L1171 646L1170 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M1171 645L1171 646L1181 646L1171 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M1181 645L1182 646L1181 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1182 645L1183 646L1182 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M141 646L142 647L141 646M145 646L146 647L145 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M171 646L172 647L171 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M186 646L187 647L186 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M140 647L141 648L140 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M146 647L147 648L146 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M147 647L148 648L147 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M170 647L171 648L170 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M186 647L187 648L186 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M140 648L141 649L140 648M148 648L149 649L148 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M149 648L150 649L149 648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M169 648L170 649L169 648M139 649L140 650L139 649M150 649L151 650L150 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M151 649L152 650L151 649M167 649L168 650L167 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M168 649L169 650L168 649M185 649L186 650L185 649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M138 650L139 651L138 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M152 650L153 651L152 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M153 650L154 651L153 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M154 650L155 651L154 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M165 650L166 651L165 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M166 650L167 651L166 650z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M185 650L186 651L185 650M137 651L138 652L137 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M155 651L155 652L158 652L155 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M158 651L158 652L162 652L158 651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M162.667 651.333L163.333 651.667L162.667 651.333M184 651L185 652L184 651M137 652L138 653L137 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M184 652L185 653L184 652M933 652L933 657L933 652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M136 653L137 654L136 653M183 653L184 654L183 653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M135 654L136 655L135 654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M183 654L184 655L183 654M135 655L136 656L135 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M136 655L137 656L136 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M182 655L183 656L182 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M673 655L674 656L673 655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M137 656L138 657L137 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M181 656L182 657L181 656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M671.333 656.667L671.667 657.333L671.333 656.667M698.667 656.333L699.333 656.667L698.667 656.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M138 657L139 658L138 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M180 657L181 658L180 657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M139 658L140 659L139 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M140 658L141 659L140 658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M179 658L180 659L179 658M141 659L142 660L141 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M178 659L179 660L178 659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M143 660L144 661L143 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M176 660L177 661L176 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M177 660L178 661L177 660z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M145 661L146 662L145 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M146 661L147 662L146 661M174 661L175 662L174 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M175 661L176 662L175 661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M147 662L148 663L147 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M148 662L149 663L148 662M172 662L173 663L172 662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M173 662L174 663L173 662M944.333 662.667L944.667 663.333L944.333 662.667M150 663L151 664L150 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M151 663L152 664L151 663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M152 663L153 664L152 663M168.667 663.333L169.333 663.667L168.667 663.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M170 663L171 664L170 663M155.667 664.333L156.333 664.667L155.667 664.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M157 664L157 665L160 665L157 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f9d98",
      stroke: "none"
    },
    d: "M160.667 664.333L161.333 664.667L160.667 664.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a6762",
      stroke: "none"
    },
    d: "M162 664L162 665L165 665L162 664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M165.667 664.333L166.333 664.667L165.667 664.333M952 664L952 667L953 667L952 664M461 666L465 671L461 666M718 668L712 677L713 677L718 668M950 669L949 672L950 669M959 670L958 672L960 672L959 670M319 672L320 673L319 672M458 677L462 673L458 677M957 673L956 676L957 676L957 673M448 675L448 679L451 675L448 675M640 684L640 680C635.699 679.277 625.724 671.954 624 680L608.999 684.292L600 681.758L587 685L589 688L584 690L583 690L582 690L582 688L557 688L554 685L556 683L544 683L544 684L552 684L552 688L544 688L544 684L540 685L540 686L543 688C539.599 686.3 526.689 685.245 528 680C519.512 679.905 512.922 676.33 504 677.093C492.728 678.057 478.389 684.952 468 680C468 682.944 464.341 682.663 462.333 685C458.666 689.268 453.35 694.228 450.5 699C449.13 701.293 449.394 703.527 449 706C445.825 725.918 473.851 720 488 720L489 714C489.056 716.112 488.893 718.257 491 719.5C493.617 721.044 499.042 720 502 720L530 720L623 720C637.691 720 653.412 721.621 668 720C675.61 719.154 687.372 707.153 693 702C695.372 699.829 695.99 696.388 699 696L699 695L697 694L697 693C701.355 689.684 699.113 684.687 699 680L696 682L695 682L690 680L689 675L666.039 676.217L640 684M283 676L283 680L284 680L283 676M314 676L311 684L316 676L314 676M318 676L318 678L320 676L318 676M320 684L319 684L318 681L317 681C317.33 689.78 315.105 712.846 322.742 718.972C326.943 722.344 339.775 720 345 720L407 720L398.203 703L403 680L402 680L401 684C390.758 675.189 380.965 680.586 370 682.377C363.597 683.423 353.656 682.794 347 682.491C340.963 682.216 335.977 677.512 330 676.802C324.69 676.172 322.009 679.532 320 684M112 679L104 688C102.028 678.796 85.139 686.402 80 688L80 692C68.7015 690.479 57.4418 688.762 48 683L48 691C45.1562 689.632 42.4288 687.253 40 690L39 690L34 688L33 693L32 693L32 689L24 689L24 688L30 688L30 687L0 683L0 720L285 720L286 680L283 688L282 688L282 680L281 680L281 688L269.326 687.157L257.996 681.863L240.961 689.553L233 688.225L206 694C207.285 689.836 209.789 688.565 214 688L208 679C201.526 679.818 191.518 682.181 186 678L185 678L184 678L184 680C177.285 676.385 165.548 675.613 158.171 677.975C148.404 681.101 135.615 689.795 128 677L112 679M270 677L271 680L272 680L270 677M456 678L456 680L458 680L456 678M472 678L473 679L472 678M477 678L480 680L480 679L477 678M847 678L832 691L832 687L822 687L824 690L808 694C806.81 690.309 804.808 688.578 801 688L802 680L801 680L797 692L796 704L795 704L792 694L792 699L791 699L789 690L788 690L784 702L782 701L783 704C779.396 706.469 779.215 709.919 780 714L779 714L779 712L778 712L776 720L912 720L945 720L958 718L959 718L960 718C964.866 723.568 986.642 720 994 720L993 704L992 704L991 708C985.911 701.395 983.174 702.969 976 700C979.943 698.234 983.202 697.61 984 693L976 692L959.001 699.447L943 696L946 680C939.352 684.062 935.739 692.992 933 700L926 700L927 688L925 688L924 694L923 691L917 699L915 697L914 697L912 699L911 696L900 707L904 704C904.643 699.839 906.218 697.822 910 696L904 688L904 694L894 696L892 688L875.018 690.259L865.946 684.668L855 685L855 688L851 688L847 678M397 679L397 680L400 680L397 679M403 679L404 680L403 679M705.333 680.667L705.667 681.333L705.333 680.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M466 684L467 685L466 684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M705 684L699 695C702.748 692.875 706.447 688.442 705 684M957 684L954 688L957 684M794 685L795 686L794 685M792 686L791 688L793 688L792 686M983.333 686.667L983.667 687.333L983.333 686.667M64 687L64 688L70 688L64 687M71 687L72 688L71 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M319 687L320 688L319 687M471 687L472 688L471 687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M895 687L896 688L895 687M789 688L790 689L789 688M885 688L886 689L885 688M994 688L995 720L1050 720C1056.6 720 1066.43 721.901 1072 718L1080 720L1080 713L1077 701C1074.46 702.931 1065.33 727.36 1064 708C1059.61 707.495 1056.83 707.033 1056 712L1054 712L1056 694L1048 699L1048 696L1044 697C1043.4 700.791 1041.66 702.87 1038 704L1038 712L1037 712C1037.05 705.693 1038.56 701.246 1033 697L1030 701L1029 691L1028 691L1024 704L1016 702L1016 706L1011 705L1011 706L1013 706L1013 707L1008 707L1008 699L1000 698L997 688L994 688M1102.67 688.333L1103.33 688.667L1102.67 688.333M1267 688L1268 689L1267 688M415 692C419.794 698.739 425.462 694.286 429 689C423.067 691.963 421.852 693.874 415 692M791 690L792 691L791 690M947 691L947 694L949 694L949 691L947 691M1196 692L1201 698L1203 694L1200 691L1196 692M1007 693L1007 696L1008 696L1007 693M1011 693L1011 695L1014 695L1014 693L1011 693M1035 696L1038 693L1035 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M994 694L994 696L996 696L994 694M1200 695L1201 696L1200 695M33 696L33 704L35 704L33 696M537 696L537 704L539 704L539 696L537 696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M770.333 696.667L770.667 697.333L770.333 696.667M1059 696L1059 704L1062 704L1062 696L1059 696M1182 696L1183 698L1184 698L1185 696L1182 696M1194 696L1195 697L1194 696M437 700L433 706L437 700M1252 700L1253 701L1252 700z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M848 703L856 702L848 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M991 701L989 704C991.251 703.527 992.118 703.14 991 701M1176 701L1179 704L1176 701M1197 701L1194 704L1195 710L1196 710L1197 701M1078.33 702.667L1078.67 703.333L1078.33 702.667M1107 702L1107 704L1109 704L1107 702M1251 702L1249 709L1251 702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M911 703L912 704L911 703M1000 703L1000 704L1003 704L1000 703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1160 703L1160 708L1157 707L1161 712L1160 703M1204 703L1205 704L1204 703M1120 707L1112 714L1111 714L1112 711C1105.66 707.393 1103.79 707.381 1098 712L1100 715C1096.22 722.271 1115.85 720 1120 720L1121 714L1128 717C1129.47 711.181 1126.5 708.784 1124 704L1120 707M1062.67 705.333L1063.33 705.667L1062.67 705.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M781 707L782 710L783 710L783 707L781 707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1204 707L1200 712L1200 717L1196 720L1202 720L1204 712L1208 712L1206 707L1204 707M1224 711L1222 709L1222 712L1213 716L1213 717L1230 720L1232 710L1240 711L1240 707L1224 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M984 709L986 712L984 709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1144 710L1144 712L1146 712L1144 710z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M872 711L873 712L872 711M897 711L898 712L897 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1154 711L1152 717L1153 717L1157 713L1154 711M1248 711L1249 712L1248 711M1255 711L1256 712L1255 711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M573 712L573 714L575 714L575 712L573 712M596.667 712.333L597.333 712.667L596.667 712.333M794 712L796 714L796 712L794 712M952 712L952 714L954 712L952 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1067.67 712.333L1068.33 712.667L1067.67 712.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M1104.33 712.667L1104.67 713.333L1104.33 712.667M1118 712L1120 714L1120 712L1118 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1139 712L1138 720L1149 720L1147 715L1144 715L1144 719L1143 719L1142 712L1139 712M1233 712L1232 720L1235 720L1233 712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M452 713L457 717L452 713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M682 720L688 713L682 720z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M487 714C486.789 717.476 487.665 718.887 491 720L489 714L487 714M595 714L593 718L594 718L595 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M733 714L734 720L735 720L733 714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M895.333 714.667L895.667 715.333L895.333 714.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1086 714L1084 720L1096 720L1096 715L1088 714L1086 714M1160 714L1161 715L1160 714M1091 715L1092 716L1091 715M1158 715L1155 720L1160 720L1160 715L1158 715M1189 715L1188 720L1192 720L1192 716L1189 715M1163 720L1184 720L1184 716L1176 718C1172.96 714.654 1165.43 716.629 1163 720M1245 716L1244 720L1248 720L1245 716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M893 717L894 718L893 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1134 717L1133 720L1136 720L1134 717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#022015",
      stroke: "none"
    },
    d: "M958 718L958 720L960 720L960 718L958 718M1071 718L1071 720L1073 720L1071 718M592 719L593 720L592 719M891.667 719.333L892.333 719.667L891.667 719.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314f49",
      stroke: "none"
    },
    d: "M1129 719L1130 720L1129 719z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteOrgToCoalition);
export default __webpack_public_path__ + "static/media/invite_org_to_coalition.51e882df98a9c0ffd4ca91d535962b9b.svg";
export { ForwardRef as ReactComponent };